import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.researcher.item');
import { OnInit, OnDestroy, HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import { Subscription } from 'rxjs';
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);

@Component({
    selector: 'wiz-page-researcher-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.researcher.item/view.scss */
:host {
  display: block;
  height: 100%;
}

.custom-scrollbar {
  scrollbar-width: thin;
  scrollbar-color: #c4c4c4 #f1f1f1;
}
.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
}
.custom-scrollbar::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #c4c4c4;
  border-radius: 3px;
}
.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.yearly-scroll {
  overflow-y: scroll;
  scrollbar-gutter: stable;
  scrollbar-width: thin;
  scrollbar-color: #c4c4c4 #f1f1f1;
}
.yearly-scroll::-webkit-scrollbar {
  width: 8px;
}
.yearly-scroll::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 999px;
}
.yearly-scroll::-webkit-scrollbar-thumb {
  background: #c4c4c4;
  border-radius: 999px;
}
.yearly-scroll::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.publication-paper-menu {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.publication-paper-submenu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 30;
  min-width: 96px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 6px;
  border: 1px solid #bfdbfe;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.14);
}

.publication-paper-submenu-item {
  height: 30px;
  width: 100%;
  padding: 0 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  text-align: left;
  white-space: nowrap;
  transition: background-color 0.15s ease, color 0.15s ease;
}
.publication-paper-submenu-item:hover {
  background: #eff6ff;
  color: #1d4ed8;
}

.yearly-chart-scroll {
  max-width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
  overscroll-behavior-x: contain;
  -webkit-overflow-scrolling: touch;
  scrollbar-gutter: stable both-edges;
  padding-bottom: 2px;
  scrollbar-width: auto;
  scrollbar-color: #c6d0df #eef2f7;
}
.yearly-chart-scroll::-webkit-scrollbar {
  height: 10px;
  width: 10px;
}
.yearly-chart-scroll::-webkit-scrollbar-track {
  background: #eef2f7;
  border-radius: 999px;
}
.yearly-chart-scroll::-webkit-scrollbar-thumb {
  background: #c6d0df;
  border-radius: 999px;
}
.yearly-chart-scroll::-webkit-scrollbar-thumb:hover {
  background: #aab8ca;
}

.topic-heatmap-wrap {
  max-width: 100%;
  max-height: none;
  overflow-x: auto;
  overflow-y: visible;
  overscroll-behavior-x: contain;
  -webkit-overflow-scrolling: touch;
  scrollbar-gutter: stable;
  padding-bottom: 6px;
  scrollbar-width: auto;
  scrollbar-color: #64748b #e2e8f0;
}
.topic-heatmap-wrap::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}
.topic-heatmap-wrap::-webkit-scrollbar-track {
  background: #e2e8f0;
  border-radius: 999px;
  border: 1px solid #cbd5e1;
}
.topic-heatmap-wrap::-webkit-scrollbar-thumb {
  background: #64748b;
  border-radius: 999px;
  border: 2px solid #e2e8f0;
}
.topic-heatmap-wrap::-webkit-scrollbar-thumb:hover {
  background: #475569;
}

.topic-heatmap-loading {
  min-height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #64748b;
  font-size: 13px;
}

.topic-heatmap-legend {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.topic-heatmap-legend-bar {
  width: 88px;
  height: 10px;
  border-radius: 999px;
  background: linear-gradient(90deg, rgba(74, 111, 216, 0.12) 0%, rgba(74, 111, 216, 0.85) 100%);
}

.topic-heatmap-panel {
  container-type: inline-size;
  container-name: topic-heatmap;
  max-width: 100%;
  min-width: 0;
}

.topic-heatmap-table {
  width: 100%;
  min-width: 0;
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0;
}
.topic-heatmap-table th,
.topic-heatmap-table td {
  padding: 4px 2px;
  border-bottom: 1px solid #eef2f7;
  text-align: center;
  vertical-align: middle;
  min-width: 0;
}
.topic-heatmap-table thead th {
  position: sticky;
  top: 0;
  background: #ffffff;
  z-index: 1;
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
  overflow: hidden;
  white-space: nowrap;
}
.topic-heatmap-table thead .topic-col {
  z-index: 4;
}
.topic-heatmap-table .topic-col {
  width: 168px;
  min-width: 168px;
  max-width: 168px;
  text-align: left;
  background: #ffffff;
  position: sticky;
  left: 0;
  z-index: 2;
  background-clip: padding-box;
  box-shadow: 8px 0 12px -12px rgba(15, 23, 42, 0.28);
}
.topic-heatmap-table.topic-heatmap-table-dense thead th:not(.topic-col) {
  height: 42px;
  font-size: 10px;
  line-height: 1;
  writing-mode: vertical-rl;
  transform: rotate(180deg);
}

.topic-cell-title {
  font-size: 13px;
  font-weight: 600;
  color: #111827;
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
}

.topic-main-label {
  color: #3730a3;
  font-weight: 700;
}

.topic-top-label {
  color: #92400e;
  font-weight: 700;
}

.topic-badge-main {
  display: inline-flex;
  align-items: center;
  font-size: 9px;
  font-weight: 700;
  padding: 1px 5px;
  border-radius: 4px;
  background: #e0e7ff;
  color: #3730a3;
  line-height: 1.4;
}

.topic-badge-top {
  display: inline-flex;
  align-items: center;
  font-size: 9px;
  font-weight: 700;
  padding: 1px 5px;
  border-radius: 4px;
  background: #fef3c7;
  color: #92400e;
  line-height: 1.4;
}

.topic-row-main th.topic-col {
  background: #f0f4ff !important;
  border-left: 3px solid #4A6FD8;
}

.topic-row-top th.topic-col {
  background: #fffbeb !important;
  border-left: 3px solid #f59e0b;
}

.topic-cell-keywords {
  margin-top: 4px;
  font-size: 11px;
  line-height: 1.4;
  color: #94a3b8;
}

.topic-keyword-more {
  margin-left: 4px;
  font-size: 10px;
  color: #4A6FD8;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0 2px;
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 2px;
}
.topic-keyword-more:hover {
  color: #3D5DB8;
}

.topic-keyword-summary-button,
.topic-keyword-card-button {
  margin-left: 0;
  white-space: nowrap;
  text-decoration: none;
  border: 1px solid #c7d2fe;
  border-radius: 999px;
  background: #ffffff;
  padding: 3px 8px;
}

.topic-summary-keyword-chip {
  max-width: 100%;
  min-width: 0;
}

.topic-summary-keyword-text,
.topic-cell-title,
.topic-cell-keywords {
  overflow-wrap: anywhere;
  word-break: break-word;
}

.topic-keyword-popover {
  position: absolute;
  z-index: 80;
  width: min(360px, 100% - 16px);
  min-width: min(260px, 100% - 16px);
  max-height: min(420px, 100vh - 140px);
  overflow: auto;
  overscroll-behavior: contain;
}

.topic-keyword-group-list {
  display: grid;
  gap: 8px;
}

.topic-keyword-group {
  padding: 8px;
  border: 1px solid #eef2f7;
  border-radius: 8px;
  background: #f8fafc;
}

.topic-keyword-group-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 11px;
  font-weight: 700;
  color: #3f3f46;
}

.topic-keyword-group-counts {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.topic-keyword-section {
  margin-top: 8px;
}

.topic-keyword-section-primary {
  margin-top: 6px;
}

.topic-keyword-section-label {
  margin-bottom: 4px;
  font-size: 10px;
  font-weight: 700;
  color: #64748b;
}

.topic-publication-keyword-chip {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  gap: 4px;
  padding: 2px 6px;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  background: #ffffff;
  color: #334155;
  font-size: 11px;
  line-height: 1.35;
}

.topic-publication-keyword-text {
  min-width: 0;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.topic-publication-keyword-count {
  flex-shrink: 0;
  color: #64748b;
  font-size: 10px;
}

.topic-keyword-empty {
  margin-top: 8px;
  color: #94a3b8;
  font-size: 11px;
}

.keyword-classification-overview {
  display: grid;
  gap: 8px;
  margin-bottom: 12px;
}

.keyword-classification-bar {
  display: flex;
  width: 100%;
  height: 12px;
  overflow: hidden;
  border: 1px solid #cfe0f7;
  border-radius: 999px;
  background: #f6f9ff;
}

.keyword-classification-bar-segment {
  min-width: 4px;
  height: 100%;
  opacity: 0.94;
}

.keyword-classification-category-grid {
  display: flex;
  align-items: stretch;
  gap: 0;
  min-height: 34px;
  max-height: 34px;
  overflow: hidden;
  border: 1px solid #e6eefb;
  border-top: 0;
  border-radius: 0 0 8px 8px;
  background: #ffffff;
}

.keyword-classification-category-item {
  display: grid;
  grid-template-columns: 8px minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 4px;
  min-width: 0;
  padding: 6px 6px;
  border-left: 1px solid #e6eefb;
  color: #355072;
  font-size: 11px;
  line-height: 1.35;
}
.keyword-classification-category-item:first-child {
  border-left: 0;
}

.keyword-classification-category-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  opacity: 0.9;
}

.keyword-classification-category-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 700;
  color: #1e3a8a;
}

.keyword-classification-category-pct,
.keyword-classification-category-count {
  color: #3f5f85;
  font-size: 10px;
  font-weight: 700;
  white-space: nowrap;
}

.keyword-classification-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 8px;
  max-height: 360px;
  overflow-y: auto;
  padding-right: 4px;
  scrollbar-width: thin;
  scrollbar-color: #b8cdec #eef5ff;
}

.keyword-classification-list::-webkit-scrollbar {
  width: 8px;
}

.keyword-classification-list::-webkit-scrollbar-track {
  background: #eef5ff;
  border-radius: 999px;
}

.keyword-classification-list::-webkit-scrollbar-thumb {
  background: #b8cdec;
  border-radius: 999px;
}

.keyword-classification-row {
  display: grid;
  grid-template-rows: auto 1fr;
  gap: 8px;
  height: 174px;
  min-width: 0;
  padding: 10px 10px 10px 11px;
  border: 1px solid #dce7f7;
  border-left-width: 3px;
  border-radius: 8px;
}

.keyword-classification-row-empty {
  border-style: dashed;
  opacity: 0.78;
}

.keyword-classification-head {
  min-width: 0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}

.keyword-classification-title {
  font-size: 12px;
  font-weight: 800;
  line-height: 1.35;
  color: #111827;
  overflow-wrap: anywhere;
}

.keyword-classification-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 4px;
}
.keyword-classification-meta span {
  display: inline-flex;
  max-width: 100%;
  padding: 2px 6px;
  border-radius: 4px;
  background: #eef4ff;
  color: #315a9a;
  font-size: 10px;
  font-weight: 800;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.keyword-classification-count {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 1px;
  flex-shrink: 0;
  color: #3f5f85;
  font-size: 10px;
  font-weight: 800;
  line-height: 1.25;
}

.keyword-classification-keywords {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  gap: 5px;
  min-width: 0;
  max-height: 96px;
  overflow: hidden;
}

.keyword-classification-chip {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  gap: 4px;
  padding: 3px 7px;
  border: 1px solid #cfe0f7;
  border-radius: 999px;
  background: #f8fbff;
  color: #1e3a8a;
  font-size: 11px;
  line-height: 1.3;
}

.keyword-classification-chip-text {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.keyword-classification-chip-count {
  flex-shrink: 0;
  min-width: 15px;
  padding: 1px 5px;
  border-radius: 999px;
  background: #edf4ff;
  color: #315a9a;
  font-size: 10px;
  font-weight: 800;
  text-align: center;
}

.keyword-classification-empty-chip {
  display: inline-flex;
  align-items: center;
  min-height: 22px;
  padding: 3px 7px;
  border: 1px dashed #bcd0ec;
  border-radius: 999px;
  background: #f8fbff;
  color: #7892b8;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.3;
}

.keyword-classification-more {
  display: inline-flex;
  align-items: center;
  min-height: 22px;
  padding: 2px 8px;
  border: 1px solid #bdd1f0;
  border-radius: 999px;
  background: #f3f7ff;
  color: #1e4f9a;
  font-size: 11px;
  font-weight: 800;
  line-height: 1.3;
  cursor: pointer;
}
.keyword-classification-more:hover {
  background: #e8f1ff;
}

.keyword-classification-modal-keywords {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  gap: 8px;
}

.keyword-classification-modal-chip {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  gap: 5px;
  padding: 5px 9px;
  border: 1px solid #cfe0f7;
  border-radius: 999px;
  background: #f8fbff;
  color: #1e3a8a;
  font-size: 12px;
  line-height: 1.35;
}

.keyword-classification-modal-chip-text {
  min-width: 0;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.topic-cell-keywords-full {
  display: block;
  margin-top: 2px;
  font-size: 11px;
  line-height: 1.4;
  color: #94a3b8;
}

.topic-heatmap-cell {
  position: relative;
  width: 100%;
  min-width: 0;
  height: 26px;
  border-radius: 6px;
  border: 1px solid transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: default;
  transition: border-color 120ms ease, box-shadow 120ms ease;
}
.topic-heatmap-cell:hover {
  border-color: rgba(31, 41, 55, 0.2);
  box-shadow: inset 0 0 0 1px rgba(31, 41, 55, 0.12);
}

.topic-heatmap-tooltip {
  position: absolute;
  transform: translate(-50%, -100%);
  z-index: 70;
  width: min(320px, 100% - 16px);
  white-space: normal;
  overflow-wrap: anywhere;
  text-align: left;
  pointer-events: none;
  padding: 8px 10px;
  background: #1f2937;
  color: #ffffff;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.4;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.topic-heatmap-tooltip-title {
  font-size: 12px;
  font-weight: 700;
  color: #ffffff;
}

.topic-heatmap-tooltip-meta {
  margin-top: 2px;
  color: #cbd5e1;
  font-size: 10px;
}

.topic-heatmap-tooltip-label {
  margin-top: 7px;
  margin-bottom: 4px;
  color: #cbd5e1;
  font-size: 10px;
  font-weight: 700;
}

.topic-heatmap-tooltip-keywords {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.topic-heatmap-tooltip-keyword {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  max-width: 100%;
  padding: 2px 5px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.12);
  color: #ffffff;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.topic-heatmap-tooltip-count {
  color: #cbd5e1;
  font-size: 10px;
  white-space: nowrap;
}

.topic-heatmap-value {
  font-size: 11px;
  font-weight: 700;
}

.topic-heatmap-card-list {
  display: none;
  max-width: 100%;
  min-width: 0;
}

.topic-heatmap-card {
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  padding: 12px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #ffffff;
}
.topic-heatmap-card.topic-row-main {
  border-left: 3px solid #4A6FD8;
  background: #f8faff;
}
.topic-heatmap-card.topic-row-top {
  border-left: 3px solid #f59e0b;
  background: #fffdf5;
}

.topic-heatmap-card-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  min-width: 0;
}

.topic-heatmap-card-scroll {
  margin-top: 10px;
  display: flex;
  gap: 4px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: scroll;
  overflow-y: hidden;
  overscroll-behavior-x: contain;
  -webkit-overflow-scrolling: touch;
  scrollbar-gutter: stable both-edges;
  padding-bottom: 8px;
  scrollbar-width: auto;
  scrollbar-color: #c6d0df #eef2f7;
}
.topic-heatmap-card-scroll::-webkit-scrollbar {
  height: 10px;
}
.topic-heatmap-card-scroll::-webkit-scrollbar-track {
  background: #eef2f7;
  border-radius: 999px;
}
.topic-heatmap-card-scroll::-webkit-scrollbar-thumb {
  background: #c6d0df;
  border-radius: 999px;
}
.topic-heatmap-card-scroll::-webkit-scrollbar-thumb:hover {
  background: #aab8ca;
}

.topic-heatmap-card .topic-cell-title,
.topic-heatmap-card .topic-cell-keywords {
  white-space: normal;
}
.topic-heatmap-card .topic-heatmap-cell {
  height: 32px;
}

.topic-heatmap-card-year {
  flex: 0 0 52px;
  width: 52px;
  min-width: 52px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.topic-heatmap-card-year-label {
  text-align: center;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.2;
  color: #64748b;
}

@container topic-heatmap (max-width: 1180px) {
  .topic-heatmap-wrap {
    max-height: clamp(320px, 52vh, 560px);
    overflow-x: auto;
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
    scrollbar-gutter: stable;
    padding-bottom: 6px;
    scrollbar-width: auto;
    scrollbar-color: #64748b #e2e8f0;
  }
  .topic-heatmap-wrap::-webkit-scrollbar {
    width: 12px;
    height: 12px;
  }
  .topic-heatmap-wrap::-webkit-scrollbar-track {
    background: #e2e8f0;
    border-radius: 999px;
    border: 1px solid #cbd5e1;
  }
  .topic-heatmap-wrap::-webkit-scrollbar-thumb {
    background: #64748b;
    border-radius: 999px;
    border: 2px solid #e2e8f0;
  }
  .topic-heatmap-wrap::-webkit-scrollbar-thumb:hover {
    background: #475569;
  }
  .topic-heatmap-table {
    min-width: 980px;
  }
  .topic-heatmap-table th:not(.topic-col),
  .topic-heatmap-table td {
    width: 40px;
    min-width: 40px;
  }
  .topic-heatmap-table.topic-heatmap-table-dense {
    min-width: 1120px;
  }
  .topic-heatmap-table.topic-heatmap-table-dense th:not(.topic-col),
  .topic-heatmap-table.topic-heatmap-table-dense td {
    width: 34px;
    min-width: 34px;
  }
}
@container topic-heatmap (max-width: 820px) {
  .topic-heatmap-wrap {
    display: none;
  }
  .topic-heatmap-card-list {
    display: grid;
    gap: 12px;
  }
}
.metric-help {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: help;
}

.metric-help-trigger {
  width: 20px;
  height: 20px;
  border: 1px solid #d4d4d8;
  border-radius: 999px;
  background: #ffffff;
  color: #a1a1aa;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  cursor: help;
  transition: color 0.15s ease, border-color 0.15s ease, background-color 0.15s ease;
}

.metric-help:hover .metric-help-trigger,
.metric-help:focus-within .metric-help-trigger {
  color: #52525b;
  border-color: #a1a1aa;
  background: #fafafa;
}

.metric-help-tooltip {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  z-index: 30;
  width: min(320px, 100vw - 32px);
  padding: 14px 16px;
  border-radius: 14px;
  background: #27272a;
  color: #ffffff;
  box-shadow: 0 20px 45px rgba(24, 24, 27, 0.28);
  opacity: 0;
  visibility: hidden;
  transform: translate(-8px, 4px);
  transition: opacity 0.15s ease, visibility 0.15s ease, transform 0.15s ease;
  pointer-events: none;
  cursor: help;
}

.metric-help:hover .metric-help-tooltip,
.metric-help:focus-within .metric-help-tooltip {
  opacity: 1;
  visibility: visible;
  transform: translate(-8px, 0);
}

.metric-help-title {
  margin: 0 0 8px;
  font-size: 12px;
  font-weight: 600;
}

.metric-help-copy {
  margin: 0;
  font-size: 11px;
  line-height: 1.55;
  color: #d4d4d8;
}

.metric-help-copy + .metric-help-copy {
  margin-top: 6px;
}

.metric-help-value {
  color: #93c5fd;
  font-weight: 600;
}

.metric-dual-ring-vertical {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  min-height: 0;
  flex: 1;
  justify-content: center;
}

.metric-dual-ring-chart {
  width: 180px;
  height: 180px;
  border-radius: 999px;
  padding: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.metric-dual-ring-inner {
  width: 100%;
  height: 100%;
  border-radius: 999px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.metric-dual-ring-value {
  font-size: 20px;
  font-weight: 700;
  color: #4a6fd8;
  line-height: 1;
}

.metric-dual-ring-label {
  margin-top: 4px;
  font-size: 10px;
  color: #64748b;
}

.metric-dual-ring-legend-bottom {
  width: 100%;
  text-align: center;
  padding-top: 4px;
}

.metric-dot {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  display: inline-flex;
  flex-shrink: 0;
}

.metric-vertical-compare {
  display: grid;
  gap: 14px;
  min-height: 0;
  align-content: space-between;
}

.metric-vertical-columns {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  align-items: end;
}

.metric-vertical-column {
  display: grid;
  justify-items: center;
  gap: 8px;
}

.metric-vertical-track {
  width: 100%;
  max-width: 92px;
  height: clamp(112px, 14vw, 156px);
  padding: 8px;
  border-radius: 18px;
  background: linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%);
  display: flex;
  align-items: flex-end;
}

.metric-vertical-fill {
  width: 100%;
  min-height: 8px;
  border-radius: 14px;
  transition: height 0.2s ease;
}

.metric-vertical-caption {
  font-size: 11px;
  color: #64748b;
}

.metric-vertical-value {
  font-size: 13px;
  font-weight: 700;
}

.metric-vertical-summary {
  border-top: 1px solid #eef2f7;
  padding-top: 12px;
}

.metric-hhi-layout {
  display: grid;
  gap: 16px;
  align-content: center;
}

.metric-hhi-scale-wrap {
  position: relative;
  padding: 8px 0;
}

.metric-hhi-scale {
  width: 100%;
  height: 18px;
  border-radius: 999px;
  background: linear-gradient(to right, #8B5CF6, #C4B5FD, #E5E7EB, #FCD34D, #F59E0B);
}

.metric-hhi-marker {
  position: absolute;
  top: 50%;
  width: 16px;
  height: 16px;
  border-radius: 999px;
  background: #ffffff;
  border: 2px solid #3f3f46;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.18);
  transform: translate(-50%, -50%);
}

.yearly-filter-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 7px 12px;
  border-width: 1px;
  border-style: solid;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  transition: color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease;
}

@media (max-width: 900px) {
  .keyword-classification-row {
    grid-template-columns: 1fr;
    gap: 10px;
  }
  .keyword-classification-head {
    align-items: flex-start;
  }
  .metric-vertical-track {
    height: 132px;
  }
  .topic-heatmap-wrap {
    display: none;
  }
  .topic-heatmap-card-list {
    display: grid;
    gap: 12px;
  }
}`],
})
export class PageResearcherItemComponent implements OnInit, OnDestroy {

    @HostListener('document:click')
    onDocumentClick() {
        let shouldRender = false;
        if (this.topicKeywordCard) {
            this.topicKeywordCard = null;
            shouldRender = true;
        }
        if (this.topicHeatmapTooltip) {
            this.topicHeatmapTooltip = null;
            shouldRender = true;
        }
        if (this.paperFilterMenuOpen) {
            this.clearPaperFilterMenuCloseTimer();
            this.paperFilterMenuOpen = false;
            this.paperFilterMenuSuppressed = false;
            shouldRender = true;
        }
        if (shouldRender) {
            this.service.render();
        }
    }

    @HostListener('document:mousemove', ['$event'])
    onDocumentMouseMove(event: MouseEvent) {
        if (!this.topicHeatmapTooltip) return;
        const target = event.target as any;
        const element = target?.closest ? target : target?.parentElement;
        if (element?.closest?.('.topic-heatmap-cell')) return;
        this.hideTopicHeatmapTooltip();
    }

    public id: string = '';
    public tab: string = 'summary';
    public researcher: any = null;
    public summary: any = null;
    public topPubs: any[] = [];
    public stats: any = null;
    public publications: any[] = [];
    public pubTotal: number = 0;
    public pubPage: number = 1;
    public pubDump: number = 10;
    public pubLastPage: number = 1;
    public pubSort: string = 'pub_year';
    public pubSortOrder: string = 'DESC';
    public pubSearchText: string = '';
    public pubFilterType: string = '';
    public pubTypeCounts: any = { all: 0, paper: 0, paper_domestic: 0, paper_overseas: 0, patent: 0, report: 0 };
    public paperFilterMenuOpen: boolean = false;
    private paperFilterMenuSuppressed: boolean = false;
    private paperFilterMenuCloseTimer: any = null;
    public yearlyData: any[] = [];
    public related: any[] = [];
    public coauthors: any[] = [];
    public network: any = null;
    public networkMeta: any = null;
    public loading: boolean = true;
    public isLoggedIn: boolean = false;
    public isAdmin: boolean = false;
    public isBookmarked: boolean = false;
    public topCoauthors: any[] = [];
    public relatedOrgs: any[] = [];
    public authorIndexStats: any = null;
    public researchProfile: any = null;
    public showProfileHelp: boolean = false;
    public showAllYearly: boolean = false;
    public showAllKeywords: boolean = false;
    private keywordFocusTerms: string[] = [];
    public collabThreshold: number = 1;
    public collabThresholdFloor: number = 1;
    public topicProfile: any = null;
    public topicProfileLoading: boolean = false;
    public yearlyCategoryView: string = 'all';
    public expandedTopicLabels: Set<string> = new Set();
    private keywordClassificationVisibleCounts: { [key: string]: number } = {};
    public keywordClassificationViewGroups: any[] = [];
    public keywordClassificationViewBars: any[] = [];
    public keywordClassificationViewTotal: number = 0;
    public keywordClassificationViewGroupCount: number = 0;
    public keywordClassificationViewSourceLabel: string = '';
    public keywordClassificationModalGroup: any = null;
    public topicKeywordCard: any = null;
    public topicKeywordCardPos: any = { top: 8, left: 8 };
    public topicHeatmapTooltip: any = null;
    public topicHeatmapTooltipPos: any = { top: 8, left: 8 };
    private readonly keywordClassificationCollapsedLimit: number = 6;
    private readonly keywordClassificationMoreStep: number = 12;
    private readonly standardTopicCategoryOrder: string[] = [
        '수학', '물리학', '화학', '지구과학', '생명과학', '농림수산식품',
        '보건의료', '기계', '재료', '화공', '전기·전자', '정보·통신',
        '에너지·자원', '원자력', '환경', '건설·교통', '우주항공',
        '국방', '안전', '생활', '지식서비스', '인문·사회과학',
    ];
    private readonly keywordClassificationPalette: string[] = [
        '#061A40', '#0B3D91', '#075985', '#1D4ED8', '#0369A1', '#2563EB',
        '#0284C7', '#3B82F6', '#0EA5E9', '#60A5FA', '#38BDF8', '#BAE6FD',
    ];

    // 뉴스 기사
    public newsArticles: any[] = [];
    public newsLoading: boolean = false;
    public newsInsights: any = null;
    public hiddenNewsArticles: any[] = [];
    public showHiddenNews: boolean = false;
    public newsActivityFilter: string = '';
    public normalArticlePage: number = 1;
    public normalArticleDump: number = 10;
    private newsActionLoadingIds: Set<string> = new Set();
    private newsCharts: Chart[] = [];

    // 연구 트렌드
    public scholarData: any = null;
    public trendData: any = null;
    public trendLoading: boolean = false;
    public trendError: string = '';
    private trendCharts: Chart[] = [];
    private summaryCharts: Chart[] = [];
    public scholarPubPage: number = 1;
    public scholarPubDump: number = 10;

    // 모달 상태
    public showPubModal: boolean = false;
    public modalPubRootType: string = '';
    public modalPubType: string = '';
    public modalPubs: any[] = [];
    public modalPubLoading: boolean = false;
    public modalPubPage: number = 1;
    public modalPubDump: number = 20;
    public modalPubTotal: number = 0;
    public modalPubLastPage: number = 1;

    // 공동 성과 모달 상태
    public showCollabModal: boolean = false;
    public collabModalCoauthor: any = null;
    public collabModalType: string = '';
    public collabModalPaperType: string = 'paper';
    public collabModalPubs: any[] = [];
    public collabModalLoading: boolean = false;
    public collabModalPage: number = 1;
    public collabModalDump: number = 10;
    public collabModalTotal: number = 0;
    public collabModalLastPage: number = 1;
    public collabTypeCounts: any = { all: 0, paper: 0, paper_domestic: 0, paper_overseas: 0, report: 0, patent: 0 };

    // 네트워크 탭 페이지네이션
    public coauthorPage: number = 1;
    public relatedPage: number = 1;
    public netPageSize: number = 5;

    // 연도 필터
    public yearFrom: number = 0;
    public yearTo: number = 0;
    public yearOptions: number[] = [];
    public filteredStats: any = null;

    // toast
    public toastMessage: string = '';
    public toastVisible: boolean = false;
    private toastTimer: any = null;

    private routerSub: Subscription | null = null;
    private animFrame: number = 0;
    private yearFilterHandler: any;
    private topicProfileLoadedForId: string = '';
    private topicProfileResolvedForId: string = '';
    private researchProfileRequestSeq: number = 0;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    private normalizeTab(tab: string): string {
        const nextTab = tab || 'summary';
        if (nextTab === 'trend') return 'summary';
        if (['summary', 'publications', 'network', 'news'].includes(nextTab)) {
            return nextTab;
        }
        return 'summary';
    }

    private normalizeKeywordTerm(value: any): string {
        return String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
    }

    private containsKoreanText(value: any): boolean {
        return /[가-힣]/.test(String(value || ''));
    }

    private isKorLikeKeywordItem(item: any): boolean {
        const lang = String(item?.lang || '').trim().toLowerCase();
        const domestic = String(item?.domestic || '').trim().toUpperCase();
        return item?.is_korean_keyword === true
            || domestic === 'Y'
            || ['kor', 'ko', 'korean'].includes(lang)
            || this.containsKoreanText(item?.display || item?.keyword || '');
    }

    private preferKoreanKeywordItems(items: any[], limit: number = 80): any[] {
        const rows = Array.isArray(items) ? items : [];
        const koreanRows = rows.filter((item: any) => this.isKorLikeKeywordItem(item));
        const source = koreanRows.length > 0 ? koreanRows : rows;
        return source.slice(0, limit);
    }

    private splitKeywordParam(value: string | null): string[] {
        if (!value) return [];
        return value
            .split(/[;,|]/)
            .map((keyword: string) => keyword.trim())
            .filter((keyword: string) => keyword);
    }

    private uniqueKeywordTerms(keywords: string[]): string[] {
        const seen = new Set<string>();
        return keywords.filter((keyword: string) => {
            const key = this.normalizeKeywordTerm(keyword);
            if (!key || seen.has(key)) return false;
            seen.add(key);
            return true;
        });
    }

    private readKeywordFocusTermsFromUrl(): string[] {
        const params = new URLSearchParams(location.search);
        return this.uniqueKeywordTerms([
            ...this.splitKeywordParam(params.get('keywords')),
            ...this.splitKeywordParam(params.get('keyword'))
        ]).slice(0, 20);
    }

    private hasKeywordFocusChanged(nextTerms: string[]): boolean {
        if (nextTerms.length !== this.keywordFocusTerms.length) return true;
        return nextTerms.some((term: string, index: number) => {
            return this.normalizeKeywordTerm(term) !== this.normalizeKeywordTerm(this.keywordFocusTerms[index]);
        });
    }

    private buildResearcherRoute(id: string, tab: string = ''): string {
        const path = tab ? `/researcher/${id}/${tab}` : `/researcher/${id}`;
        if (this.keywordFocusTerms.length === 0) return path;

        const params = new URLSearchParams();
        params.set('keywords', this.keywordFocusTerms.join('|'));
        return `${path}?${params.toString()}`;
    }

    private normalizeCollabThreshold(value: number): number {
        const minThreshold = Math.max(1, this.collabThresholdFloor || 1);
        const parsed = Math.floor(Number(value) || minThreshold);
        return Math.max(minThreshold, Math.min(50, parsed));
    }

    private getPageScrollContainer(): HTMLElement | null {
        const routerOutlet = document.querySelector('router-outlet');
        const container = routerOutlet?.parentElement as HTMLElement | null;
        if (container) return container;
        return document.querySelector('.flex-1.min-h-0.overflow-auto') as HTMLElement | null;
    }

    private scrollPageToTop() {
        const container = this.getPageScrollContainer();
        if (container) {
            container.scrollTo({ top: 0, left: 0, behavior: 'auto' });
            container.scrollTop = 0;
            container.scrollLeft = 0;
        }
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    }

    private resetResearcherPageScroll() {
        this.scrollPageToTop();
        setTimeout(() => this.scrollPageToTop(), 0);
    }

    public async ngOnInit() {
        await this.service.init();
        this.id = WizRoute.segment.id;
        this.tab = this.normalizeTab(WizRoute.segment.tab || 'summary');
        this.keywordFocusTerms = this.readKeywordFocusTermsFromUrl();

        if ((WizRoute.segment.tab || 'summary') !== this.tab) {
            this.service.href(this.buildResearcherRoute(this.id, this.tab));
            return;
        }

        this.resetResearcherPageScroll();

        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                const newId = WizRoute.segment.id;
                const newTab = this.normalizeTab(WizRoute.segment.tab || 'summary');
                const nextKeywordFocusTerms = this.readKeywordFocusTermsFromUrl();
                if ((WizRoute.segment.tab || 'summary') !== newTab) {
                    this.keywordFocusTerms = nextKeywordFocusTerms;
                    this.service.href(this.buildResearcherRoute(newId, newTab));
                    return;
                }
                if (newId !== this.id) {
                    this.id = newId;
                    this.tab = newTab;
                    this.keywordFocusTerms = nextKeywordFocusTerms;
                    this.resetResearcherPageScroll();
                    this.showAllKeywords = false;
                    this.yearFrom = 0;
                    this.yearTo = 0;
                    this.filteredStats = null;
                    this.topicProfile = null;
                    this.topicProfileLoading = false;
                    this.topicProfileLoadedForId = '';
                    this.topicProfileResolvedForId = '';
                    this.keywordClassificationVisibleCounts = {};
                    this.resetKeywordClassificationView();
                    this.destroySummaryCharts();
                    this.loading = true;
                    await this.service.render();
                    await this.loadResearcher();
                    await this.checkSession();
                    await this.loadTab();
                    this.loading = false;
                    await this.service.render();
                    this.resetResearcherPageScroll();
                } else {
                    const tabChanged = newTab !== this.tab;
                    const keywordFocusChanged = this.hasKeywordFocusChanged(nextKeywordFocusTerms);
                    if (keywordFocusChanged) {
                        this.keywordFocusTerms = nextKeywordFocusTerms;
                    }
                    if (tabChanged) {
                        this.tab = newTab;
                        await this.loadTab();
                    }
                    if (tabChanged || keywordFocusChanged) {
                        await this.service.render();
                    }
                }
            }
        });

        await this.loadResearcher();
        await this.checkSession();
        await this.loadTab();
        this.loading = false;

        // 챗봇 연도 필터 이벤트 수신
        this.yearFilterHandler = async (e: any) => {
            const { yearFrom, yearTo } = e.detail;
            if (yearFrom) this.yearFrom = yearFrom;
            if (yearTo) this.yearTo = yearTo;
            await this.applyYearFilter();
        };
        window.addEventListener('chatbot-year-filter', this.yearFilterHandler);

        await this.service.render();
        this.resetResearcherPageScroll();
    }

    ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
        if (this.animFrame) cancelAnimationFrame(this.animFrame);
        this.clearPaperFilterMenuCloseTimer();
        if (this.yearFilterHandler) window.removeEventListener('chatbot-year-filter', this.yearFilterHandler);
        this.destroySummaryCharts();
        this.destroyNewsCharts();
        this.destroyTrendCharts();
    }

    // ─── 연도 필터 ───
    public get isYearFiltered(): boolean {
        return this.yearFrom > 0 || this.yearTo > 0;
    }

    public get yearToOptions(): number[] {
        if (this.yearFrom > 0) {
            return this.yearOptions.filter(y => y >= this.yearFrom);
        }
        return this.yearOptions;
    }

    public async onYearFromChange(val: number) {
        this.yearFrom = val;
        if (this.yearTo > 0 && this.yearTo < this.yearFrom) {
            this.yearTo = this.yearFrom;
        }
        await this.applyYearFilter();
    }

    public get filteredYearlyData(): any[] {
        if (!this.isYearFiltered) return this.yearlyData;
        return this.yearlyData.filter(y => {
            if (this.yearFrom > 0 && y.pub_year < this.yearFrom) return false;
            if (this.yearTo > 0 && y.pub_year > this.yearTo) return false;
            return true;
        });
    }

    public get displayYearlyData(): any[] {
        const data = this.filteredYearlyData;
        return data;
    }

    public get topicHeatmapYears(): number[] {
        const years = this.topicProfile?.years || [];
        const rows = this.topicProfile?.topic_heatmap || [];
        return years.filter((year: number) => {
            if (this.yearFrom > 0 && year < this.yearFrom) return false;
            if (this.yearTo > 0 && year > this.yearTo) return false;
            // 모든 토픽이 0인 년도 제외
            const hasData = rows.some((row: any) => {
                const val = Number(row?.year_counts?.[String(year)] || 0);
                return val > 0;
            });
            return hasData;
        });
    }

    public get topicExcludedYearCount(): number {
        const allYears = this.topicProfile?.years || [];
        const filteredYears = this.topicHeatmapYears;
        const yearFiltered = allYears.filter((y: number) => {
            if (this.yearFrom > 0 && y < this.yearFrom) return false;
            if (this.yearTo > 0 && y > this.yearTo) return false;
            return true;
        });
        return yearFiltered.length - filteredYears.length;
    }

    public isMainTopic(topic: any): boolean {
        return topic?.label === this.topicProfile?.main_topic;
    }

    public isTopTopic(topic: any): boolean {
        const topTopics = this.topicProfile?.top_topics || [];
        if (topTopics.length === 0) return false;
        return topic?.label === topTopics[0]?.topic;
    }

    public getMainTopicCount(): number {
        const topTopics = this.topicProfile?.top_topics || [];
        const mainTopic = this.topicProfile?.main_topic;
        if (!mainTopic) return 0;
        const found = topTopics.find((t: any) => t.topic === mainTopic);
        return Number(found?.distinct_keyword_count || found?.keyword_count || found?.count || 0);
    }

    private getMainTopicRow(): any {
        const mainTopic = this.topicProfile?.main_topic;
        if (!mainTopic) return null;
        const rows = this.topicHeatmapRows || [];
        return rows.find((row: any) => row?.label === mainTopic || row?.topic === mainTopic) || null;
    }

    public getMainTopicKeywordItems(limit: number = 5): any[] {
        const mainTopicRow = this.getMainTopicRow();
        if (!mainTopicRow) return [];
        return this.getTopicPublicationKeywordItems(mainTopicRow, limit);
    }

    public showTopicHeatmapTooltip(event: MouseEvent, topic: any, year: number) {
        const target = event.currentTarget as HTMLElement;
        const panel = target?.closest('.topic-heatmap-panel') as HTMLElement;
        if (target && panel) {
            const targetRect = target.getBoundingClientRect();
            const panelRect = panel.getBoundingClientRect();
            const tooltipWidth = Math.min(320, Math.max(220, panelRect.width - 16));
            const minLeft = (tooltipWidth / 2) + 8;
            const maxLeft = Math.max(minLeft, panelRect.width - (tooltipWidth / 2) - 8);
            const left = targetRect.left - panelRect.left + (targetRect.width / 2);
            this.topicHeatmapTooltipPos = {
                top: Math.max(8, targetRect.top - panelRect.top - 8),
                left: Math.min(Math.max(left, minLeft), maxLeft),
            };
        } else {
            this.topicHeatmapTooltipPos = { top: 8, left: 8 };
        }
        const value = this.getTopicHeatValue(topic, year);
        const limit = Math.max(12, Math.min(80, value || 0));
        this.topicHeatmapTooltip = {
            label: topic?.label || '토픽',
            year,
            value,
            keywords: this.getTopicPublicationKeywordItems(topic, limit, year),
        };
        this.service.render();
    }

    public hideTopicHeatmapTooltip() {
        if (!this.topicHeatmapTooltip) return;
        this.topicHeatmapTooltip = null;
        this.service.render();
    }

    public get topicHeatmapRows(): any[] {
        const years = this.topicHeatmapYears;
        const rows = this.topicProfile?.topic_heatmap || [];

        return rows
            .map((row: any) => {
                const total = years.reduce((sum: number, year: number) => sum + this.getTopicHeatValue(row, year), 0);
                return {
                    ...row,
                    filtered_total: total,
                };
            })
            .filter((row: any) => row.filtered_total > 0);
    }

    public get topicHeatmapMaxCount(): number {
        let maxCount = 0;
        for (const row of this.topicHeatmapRows) {
            for (const year of this.topicHeatmapYears) {
                maxCount = Math.max(maxCount, this.getTopicHeatValue(row, year));
            }
        }
        return maxCount;
    }

    private resetKeywordClassificationView() {
        this.keywordClassificationViewGroups = [];
        this.keywordClassificationViewBars = [];
        this.keywordClassificationViewTotal = 0;
        this.keywordClassificationViewGroupCount = 0;
        this.keywordClassificationViewSourceLabel = '';
        this.keywordClassificationVisibleCounts = {};
        this.keywordClassificationModalGroup = null;
    }

    private getKeywordMatchKey(value: any): string {
        return this.normalizeKeywordTerm(value).replace(/\s+/g, '');
    }

    private getResearcherKeywordMatchMap(): Map<string, any> {
        const keywordMap = new Map<string, any>();
        const displayTags = this.getResearcherKeywordTags();
        const displayOrderMap = new Map<string, number>();
        displayTags.forEach((tag: string, index: number) => {
            const exactKey = this.normalizeKeywordTerm(tag);
            if (exactKey && !displayOrderMap.has(exactKey)) {
                displayOrderMap.set(exactKey, index);
            }
        });

        const koreanTags = this.getRawFieldTags(this.researcher?.keyword_kor);
        const englishTags = this.getRawFieldTags(this.researcher?.keyword_eng);
        const usingKorean = koreanTags.length > 0;
        const rawDisplayTags = usingKorean ? koreanTags : englishTags;
        const rawAliasTags = usingKorean ? englishTags : [];

        const addKeyword = (value: any, display: string, fallbackOrder: number) => {
            const exactKey = this.normalizeKeywordTerm(value);
            const compactKey = this.getKeywordMatchKey(value);
            const order = displayOrderMap.get(this.normalizeKeywordTerm(display)) ?? fallbackOrder;
            const item = { display, order };

            if (exactKey && !keywordMap.has(exactKey)) {
                keywordMap.set(exactKey, item);
            }
            if (compactKey && !keywordMap.has(compactKey)) {
                keywordMap.set(compactKey, item);
            }
        };

        rawDisplayTags.forEach((display: string, index: number) => {
            addKeyword(display, display, index);
            if (rawAliasTags[index]) {
                addKeyword(rawAliasTags[index], display, index);
            }
        });

        displayTags.forEach((display: string, index: number) => {
            addKeyword(display, display, index);
        });
        return keywordMap;
    }

    private getResearcherKeywordMatch(item: any, keywordMap: Map<string, any>): any {
        if (!keywordMap.size) return null;
        const values = [
            item?.display,
            item?.keyword,
        ];

        for (const value of values) {
            const exactKey = this.normalizeKeywordTerm(value);
            if (exactKey && keywordMap.has(exactKey)) {
                return keywordMap.get(exactKey);
            }
        }
        for (const value of values) {
            const compactKey = this.getKeywordMatchKey(value);
            if (compactKey && keywordMap.has(compactKey)) {
                return keywordMap.get(compactKey);
            }
        }
        return null;
    }

    private getStandardKeywordClassificationRows(rows: any[]): any[] {
        if (!Array.isArray(rows) || !rows.length) return [];

        const researcherKeywordMap = this.getResearcherKeywordMatchMap();
        if (!researcherKeywordMap.size) return [];

        const defaultCategory = this.standardTopicCategoryOrder.includes('지식서비스')
            ? '지식서비스'
            : this.standardTopicCategoryOrder[0];
        const groupMap = new Map<string, any>();
        const seenMap = new Map<string, Set<string>>();

        this.standardTopicCategoryOrder.forEach((category: string) => {
            groupMap.set(category, {
                label: category,
                standard_category: category,
                standard_indicator: '',
                standard_topic_key: category,
                count: 0,
                keyword_total: 0,
                keywords: [],
                source: 'standard_json',
            });
            seenMap.set(category, new Set<string>());
        });

        rows.forEach((row: any) => {
            const rowCategory = this.getKeywordClassificationCategory(row);
            const category = this.standardTopicCategoryOrder.includes(rowCategory) ? rowCategory : defaultCategory;
            const target = groupMap.get(category);
            const seen = seenMap.get(category);
            if (!target || !seen) return;

            const indicator = String(row?.standard_indicator || '').trim();
            const source = String(row?.source || '').trim();
            if (indicator && !target.standard_indicator) {
                target.standard_indicator = indicator;
            }
            if (source && target.source !== source) {
                target.source = target.source === 'standard_json' ? source : 'mixed';
            }

            this.getKeywordClassificationKeywords(row).forEach((item: any) => {
                const researcherKeyword = this.getResearcherKeywordMatch(item, researcherKeywordMap)
                    || (this.isKorLikeKeywordItem(item)
                        ? { display: item?.display || item?.keyword || '', order: 999999 }
                        : null);
                if (!researcherKeyword) return;

                const key = this.normalizeKeywordTerm(researcherKeyword.display);
                if (!key || seen.has(key)) return;
                seen.add(key);

                const count = Number(item?.count || 0);
                target.keywords.push({
                    ...item,
                    display: researcherKeyword.display,
                    keyword: researcherKeyword.display,
                    source: item?.source || source || target.source,
                    standard_indicator: item?.standard_indicator || indicator,
                    similarity_score: this.getKeywordClassificationSimilarityScore(item),
                    standard_match_score: this.getKeywordClassificationSimilarityScore(item),
                    standard_match_source: item?.standard_match_source || item?.match_source || '',
                    researcher_keyword_order: researcherKeyword.order,
                });
                target.keyword_total += count > 0 ? count : 1;
            });
        });

        return this.standardTopicCategoryOrder.map((category: string) => {
            const group = groupMap.get(category);
            group.keywords = (group.keywords || []).sort((left: any, right: any) => {
                const countDiff = Number(right?.count || 0) - Number(left?.count || 0);
                if (countDiff !== 0) return countDiff;
                const similarityDiff = this.getKeywordClassificationSimilarityScore(right) - this.getKeywordClassificationSimilarityScore(left);
                if (similarityDiff !== 0) return similarityDiff;
                const sourceDiff = this.getKeywordClassificationSourcePriority(right) - this.getKeywordClassificationSourcePriority(left);
                if (sourceDiff !== 0) return sourceDiff;
                const orderDiff = Number(left?.researcher_keyword_order ?? 999999) - Number(right?.researcher_keyword_order ?? 999999);
                if (orderDiff !== 0) return orderDiff;
                return String(left?.display || '').localeCompare(String(right?.display || ''), 'ko');
            });
            group.count = group.keywords.length;
            group.keyword_total = group.keywords.length > 0 ? group.keyword_total : 0;
            return group;
        }).sort((left: any, right: any) => this.compareKeywordClassificationGroups(left, right));
    }

    private prepareKeywordClassificationView() {
        const sourceRows = Array.isArray(this.topicProfile?.keyword_classification_groups)
            ? this.topicProfile.keyword_classification_groups
            : [];
        const rows = this.getStandardKeywordClassificationRows(sourceRows);
        if (!rows.length) {
            this.resetKeywordClassificationView();
            return;
        }

        const sortedGroups = rows
            .map((group: any, index: number) => {
                const keywords = this.getKeywordClassificationKeywords(group);
                const key = this.getKeywordClassificationGroupKey(group, index);
                const category = this.getKeywordClassificationCategory(group);
                const visibleCount = Math.min(this.keywordClassificationCollapsedLimit, keywords.length);
                const hiddenCount = Math.max(keywords.length - visibleCount, 0);
                const keywordTotal = Number(group?.keyword_total || 0) || keywords.reduce((sum: number, item: any) => {
                    const itemCount = Number(item?.count || 0);
                    return sum + (itemCount > 0 ? itemCount : 1);
                }, 0);
                const keywordCount = Number(group?.count || keywords.length || 0);

                return {
                    ...group,
                    key,
                    category,
                    title: group?.label || group?.standard_indicator || category,
                    keywords,
                    keyword_count: keywords.length,
                    count: keywordCount,
                    keyword_total: keywordTotal,
                    visible_keywords: keywords.slice(0, visibleCount),
                    visible_count: visibleCount,
                    hidden_count: hiddenCount,
                    next_count: hiddenCount,
                    can_collapse: false,
                    expanded: false,
                    empty: keywords.length === 0,
                    weight: keywordTotal || keywordCount || keywords.length,
                };
            })
            .filter((group: any) => {
                return group.keyword_count > 0 && (group.title || group.category);
            })
            .sort((left: any, right: any) => this.compareKeywordClassificationGroups(left, right));

        const groups = sortedGroups
            .map((group: any, index: number) => {
                const color = this.getKeywordClassificationRankColor(index, sortedGroups.length);
                return {
                    ...group,
                    color,
                    tint: this.hexToRgba(color, group.keyword_count ? 0.072 : 0.025),
                };
            });

        const totalWeight = groups.reduce((sum: number, group: any) => sum + Number(group.weight || 0), 0);
        this.keywordClassificationViewBars = groups
            .filter((group: any) => Number(group.weight || 0) > 0)
            .map((group: any) => {
                const pct = totalWeight > 0 ? (Number(group.weight || 0) / totalWeight) * 100 : 0;
                return {
                    category: group.category,
                    keywordCount: group.keyword_count,
                    weight: group.weight,
                    pct,
                    pctLabel: this.formatKeywordClassificationPct(pct),
                    color: group.color,
                    title: `${group.category || '분류'} · 키워드 ${Number(group.keyword_count || 0).toLocaleString()}개 · ${this.formatKeywordClassificationPct(pct)}`,
                };
            });

        this.keywordClassificationViewGroups = groups;
        this.keywordClassificationViewTotal = groups.reduce((sum: number, group: any) => {
            return sum + Number(group.keyword_count || 0);
        }, 0);
        this.keywordClassificationViewGroupCount = groups.length;
        this.keywordClassificationViewSourceLabel = this.getKeywordClassificationSourceLabel();
    }

    public get keywordClassificationGroups(): any[] {
        const sourceRows = Array.isArray(this.topicProfile?.keyword_classification_groups)
            ? this.topicProfile.keyword_classification_groups
            : [];
        const rows = this.getStandardKeywordClassificationRows(sourceRows);
        return rows
            .map((group: any) => ({
                ...group,
                keywords: this.getKeywordClassificationKeywords(group),
                count: Number(group?.count || (Array.isArray(group?.keywords) ? group.keywords.length : 0) || 0),
                keyword_total: Number(group?.keyword_total || 0),
            }))
            .filter((group: any) => {
                return group.keywords.length > 0 && (group.label || group.standard_category || group.standard_indicator);
            });
    }

    public get keywordClassificationTotal(): number {
        return this.keywordClassificationGroups.reduce((sum: number, group: any) => {
            return sum + this.getKeywordClassificationKeywords(group).length;
        }, 0);
    }

    public get keywordClassificationGroupCount(): number {
        return this.keywordClassificationGroups.length;
    }

    public get keywordClassificationCategoryBars(): any[] {
        const categoryMap = new Map<string, any>();
        this.keywordClassificationGroups.forEach((group: any) => {
            const category = this.getKeywordClassificationCategory(group);
            const weight = this.getKeywordClassificationGroupWeight(group);
            const keywordCount = this.getKeywordClassificationKeywords(group).length;
            const current = categoryMap.get(category) || {
                category,
                keywordCount: 0,
                weight: 0,
                groupCount: 0,
            };
            current.keywordCount += keywordCount;
            current.weight += weight;
            current.groupCount += 1;
            categoryMap.set(category, current);
        });

        const totalWeight = Array.from(categoryMap.values()).reduce((sum: number, item: any) => {
            return sum + Number(item.weight || 0);
        }, 0);

        const categoryRows = Array.from(categoryMap.values())
            .sort((a: any, b: any) => {
                const weightDiff = Number(b.weight || 0) - Number(a.weight || 0);
                if (weightDiff !== 0) return weightDiff;
                return String(a.category || '').localeCompare(String(b.category || ''));
            });

        return categoryRows
            .map((item: any, index: number) => {
                const pct = totalWeight > 0 ? (Number(item.weight || 0) / totalWeight) * 100 : 0;
                return {
                    ...item,
                    pct,
                    pctLabel: this.formatKeywordClassificationPct(pct),
                    color: this.getKeywordClassificationRankColor(index, categoryRows.length),
                };
            });
    }

    public getKeywordClassificationCategoryTitle(item: any): string {
        return `${item?.category || '분류'} · 키워드 ${Number(item?.keywordCount || 0).toLocaleString()}개 · ${item?.pctLabel || '0%'}`;
    }

    public getKeywordClassificationSourceLabel(): string {
        const source = String(this.topicProfile?.keyword_classification_source || '').toLowerCase();
        if (source === 'ai') return 'AI 전체 분류';
        if (source === 'ai_partial') return 'AI 분류 + 자동 보정';
        if (source === 'server_fallback') return '표준분류 자동 보정';
        if (source === 'standard_json') return '표준 JSON 22개 분류';
        if (source === 'standard_json_missing') return '표준 JSON 없음';
        return '키워드 분류';
    }

    public getKeywordClassificationKeywords(group: any): any[] {
        const rows = Array.isArray(group?.keywords) ? group.keywords : [];
        const seen = new Set<string>();
        return rows
            .map((item: any) => {
                const source = typeof item === 'string' ? { keyword: item, display: item } : item;
                const display = String(source?.display || source?.keyword || '').trim();
                const key = this.normalizeKeywordTerm(display);
                if (!display || !key || seen.has(key)) return null;
                seen.add(key);
                return {
                    display,
                    keyword: String(source?.keyword || display).trim(),
                    count: Number(source?.count || 0),
                    source: source?.source || group?.source || '',
                    standard_indicator: source?.standard_indicator || group?.standard_indicator || '',
                    similarity_score: this.getKeywordClassificationSimilarityScore(source),
                    standard_match_score: this.getKeywordClassificationSimilarityScore(source),
                    standard_match_source: source?.standard_match_source || source?.match_source || '',
                    lang: source?.lang || group?.lang || '',
                    domestic: source?.domestic || group?.domestic || 'N',
                    is_korean_keyword: source?.is_korean_keyword === true || group?.is_korean_keyword === true,
                };
            })
            .filter((item: any) => item?.display);
    }

    private getKeywordClassificationSimilarityScore(item: any): number {
        const score = Number(
            item?.similarity_score
            ?? item?.standard_match_score
            ?? item?.match_score
            ?? 0
        );
        return Number.isFinite(score) ? score : 0;
    }

    private getKeywordClassificationSourcePriority(item: any): number {
        const source = String(item?.source || '').toLowerCase();
        if (source === 'topic_cluster') return 4;
        if (source === 'semantic_hint') return 3;
        if (source === 'standard_json') return 2;
        if (source === 'mixed') return 1;
        if (source.includes('fallback')) return 0;
        return 1;
    }

    public getKeywordClassificationGroupColor(group: any): string {
        return group?.color || this.getKeywordClassificationCategoryColor(this.getKeywordClassificationCategory(group));
    }

    public getKeywordClassificationGroupTint(group: any): string {
        return this.hexToRgba(this.getKeywordClassificationGroupColor(group), 0.08);
    }

    private getKeywordClassificationCategory(group: any): string {
        const category = String(group?.standard_category || group?.category || '').trim();
        return category || '표준분류 없음';
    }

    private getKeywordClassificationGroupWeight(group: any): number {
        const keywordTotal = Number(group?.keyword_total || 0);
        if (keywordTotal > 0) return keywordTotal;
        const count = Number(group?.count || 0);
        if (count > 0) return count;
        const keywords = this.getKeywordClassificationKeywords(group);
        return keywords.reduce((sum: number, item: any) => {
            const itemCount = Number(item?.count || 0);
            return sum + (itemCount > 0 ? itemCount : 1);
        }, 0);
    }

    private getKeywordClassificationCategoryColor(categoryValue: any): string {
        const category = String(categoryValue || '').trim();
        const index = this.standardTopicCategoryOrder.indexOf(category);
        if (index >= 0) {
            return this.keywordClassificationPalette[index % this.keywordClassificationPalette.length];
        }
        return this.keywordClassificationPalette[this.hashKeywordClassificationText(category) % this.keywordClassificationPalette.length];
    }

    private getKeywordClassificationRankColor(index: number, total: number = this.keywordClassificationPalette.length): string {
        const paletteMax = this.keywordClassificationPalette.length - 1;
        const normalizedTotal = Math.max(1, Math.floor(Number(total) || 1));
        const safeIndex = Math.max(0, Math.min(Math.floor(Number(index) || 0), normalizedTotal - 1));
        const paletteIndex = normalizedTotal <= 1
            ? 0
            : Math.round((safeIndex / (normalizedTotal - 1)) * paletteMax);
        return this.keywordClassificationPalette[Math.min(paletteIndex, paletteMax)];
    }

    private compareKeywordClassificationGroups(left: any, right: any): number {
        const leftWeight = this.getKeywordClassificationGroupWeight(left);
        const rightWeight = this.getKeywordClassificationGroupWeight(right);
        const weightDiff = rightWeight - leftWeight;
        if (weightDiff !== 0) return weightDiff;

        const keywordDiff = Number(right?.count || right?.keyword_count || 0) - Number(left?.count || left?.keyword_count || 0);
        if (keywordDiff !== 0) return keywordDiff;

        return String(left?.label || left?.standard_category || '').localeCompare(
            String(right?.label || right?.standard_category || ''),
            'ko'
        );
    }

    private formatKeywordClassificationPct(value: number): string {
        if (!Number.isFinite(value) || value <= 0) return '0%';
        if (value >= 10 || Math.abs(value - Math.round(value)) < 0.05) return `${Math.round(value)}%`;
        return `${value.toFixed(1)}%`;
    }

    private hashKeywordClassificationText(value: string): number {
        let hash = 0;
        const text = value || 'default';
        for (let i = 0; i < text.length; i++) {
            hash = ((hash << 5) - hash) + text.charCodeAt(i);
            hash |= 0;
        }
        return Math.abs(hash);
    }

    private hexToRgba(hex: string, alpha: number): string {
        const normalized = String(hex || '').replace('#', '');
        if (normalized.length !== 6) return `rgba(74, 111, 216, ${alpha})`;
        const value = parseInt(normalized, 16);
        const r = (value >> 16) & 255;
        const g = (value >> 8) & 255;
        const b = value & 255;
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }

    public getKeywordClassificationGroupKey(group: any, index: number): string {
        return [
            String(group?.standard_topic_key || ''),
            String(group?.label || ''),
            String(index),
        ].join('|');
    }

    private getKeywordClassificationVisibleCount(key: string, total: number): number {
        const normalizedTotal = Math.max(Number(total || 0), 0);
        if (normalizedTotal <= 0) return 0;

        const collapsedCount = Math.min(this.keywordClassificationCollapsedLimit, normalizedTotal);
        const savedCount = Number(this.keywordClassificationVisibleCounts[key] || 0);
        if (!Number.isFinite(savedCount) || savedCount <= 0) return collapsedCount;

        return Math.min(Math.max(savedCount, collapsedCount), normalizedTotal);
    }

    public isKeywordClassificationExpanded(group: any, index: number): boolean {
        const key = group?.key || this.getKeywordClassificationGroupKey(group, index);
        return this.getKeywordClassificationVisibleCount(key, this.getKeywordClassificationKeywords(group).length) > this.keywordClassificationCollapsedLimit;
    }

    public getVisibleKeywordClassificationKeywords(group: any, index: number, collapsedLimit: number = 12): any[] {
        const keywords = this.getKeywordClassificationKeywords(group);
        const key = group?.key || this.getKeywordClassificationGroupKey(group, index);
        const visibleCount = this.getKeywordClassificationVisibleCount(key, keywords.length);
        return keywords.slice(0, Math.max(visibleCount, Math.min(collapsedLimit, keywords.length)));
    }

    public getKeywordClassificationHiddenCount(group: any, index: number, collapsedLimit: number = 12): number {
        const keywords = this.getKeywordClassificationKeywords(group);
        const key = group?.key || this.getKeywordClassificationGroupKey(group, index);
        const visibleCount = this.getKeywordClassificationVisibleCount(key, keywords.length);
        return Math.max(keywords.length - Math.max(visibleCount, Math.min(collapsedLimit, keywords.length)), 0);
    }

    public async showMoreKeywordClassificationGroup(group: any, index: number = 0) {
        const key = group?.key || this.getKeywordClassificationGroupKey(group, index);
        const total = Number(group?.keyword_count || this.getKeywordClassificationKeywords(group).length || 0);
        const currentCount = this.getKeywordClassificationVisibleCount(key, total);
        this.keywordClassificationVisibleCounts[key] = Math.min(total, currentCount + this.keywordClassificationMoreStep);
        this.prepareKeywordClassificationView();
        await this.service.render();
    }

    public async collapseKeywordClassificationGroup(group: any, index: number = 0) {
        const key = group?.key || this.getKeywordClassificationGroupKey(group, index);
        delete this.keywordClassificationVisibleCounts[key];
        this.prepareKeywordClassificationView();
        await this.service.render();
    }

    public async toggleKeywordClassificationGroup(group: any, index: number = 0) {
        if (Number(group?.hidden_count || 0) > 0) {
            await this.showMoreKeywordClassificationGroup(group, index);
            return;
        }
        const key = group?.key || this.getKeywordClassificationGroupKey(group, index);
        if (this.getKeywordClassificationVisibleCount(key, Number(group?.keyword_count || 0)) > this.keywordClassificationCollapsedLimit) {
            await this.collapseKeywordClassificationGroup(group, index);
            return;
        }
        this.prepareKeywordClassificationView();
        await this.service.render();
    }

    public async openKeywordClassificationModal(group: any) {
        this.keywordClassificationModalGroup = group;
        this.topicKeywordCard = null;
        this.topicHeatmapTooltip = null;
        await this.service.render();
    }

    public async closeKeywordClassificationModal() {
        this.keywordClassificationModalGroup = null;
        await this.service.render();
    }

    public get keywordClassificationModalKeywords(): any[] {
        return this.getKeywordClassificationKeywords(this.keywordClassificationModalGroup || {});
    }

    public getKeywordClassificationModalTitle(): string {
        const group = this.keywordClassificationModalGroup || {};
        return group.title || group.label || group.standard_category || '키워드';
    }

    public getKeywordClassificationModalMeta(): string {
        const group = this.keywordClassificationModalGroup || {};
        const keywordCount = Number(group.keyword_count || this.keywordClassificationModalKeywords.length || 0);
        const totalCount = Number(group.keyword_total || 0);
        if (totalCount > 0) {
            return `키워드 ${keywordCount.toLocaleString()}개 · 누적 ${totalCount.toLocaleString()}건`;
        }
        return `키워드 ${keywordCount.toLocaleString()}개`;
    }

    public trackKeywordClassificationGroup(index: number, group: any): string {
        return group?.key || this.getKeywordClassificationGroupKey(group, index);
    }

    public trackKeywordClassificationBar(index: number, item: any): string {
        return String(item?.category || index);
    }

    public async toggleShowAllYearly() {
        this.showAllYearly = !this.showAllYearly;
        await this.service.render();
    }

    public get displayPaperCnt(): number {
        return this.isYearFiltered && this.filteredStats ? this.filteredStats.paper : (this.researcher?.paper_cnt || 0);
    }

    public get displayOverseasPaperCnt(): number {
        if (this.isYearFiltered && this.filteredStats) {
            return this.filteredStats.paper_overseas || 0;
        }
        return this.summary?.type_distribution?.paper_overseas || this.pubTypeCounts.paper_overseas || 0;
    }

    public get displayDomesticPaperCnt(): number {
        if (this.isYearFiltered && this.filteredStats) {
            return this.filteredStats.paper_domestic || 0;
        }
        const domestic = this.pubTypeCounts.paper_domestic || 0;
        if (domestic > 0) {
            return domestic;
        }
        const summaryTypes = this.summary?.type_distribution || {};
        const summaryDomestic = Number(summaryTypes.paper_domestic || summaryTypes.paper || 0);
        if (summaryDomestic > 0) return summaryDomestic;
        return Math.max(this.displayPaperCnt - this.displayOverseasPaperCnt, 0);
    }

    public get hasOverseasPapers(): boolean {
        return this.displayOverseasPaperCnt > 0 || (this.pubTypeCounts.paper_overseas || 0) > 0;
    }

    public get displayReportCnt(): number {
        return this.isYearFiltered && this.filteredStats ? this.filteredStats.report : (this.researcher?.report_cnt || 0);
    }

    public get displayPatentCnt(): number {
        return this.isYearFiltered && this.filteredStats ? this.filteredStats.patent : (this.researcher?.patent_cnt || 0);
    }

    public get displayTotalPubs(): number {
        return this.displayPaperCnt + this.displayPatentCnt + this.displayReportCnt;
    }

    public get publicationOptionTotalCount(): number {
        return this.getPublicationFilterCount('all');
    }

    public get publicationPaperFilterLabel(): string {
        if (this.pubFilterType === 'paper_domestic') return '논문(국내)';
        if (this.pubFilterType === 'paper_overseas') return '논문(해외)';
        return '논문';
    }

    public get publicationPaperFilterCount(): number {
        if (this.pubFilterType === 'paper_domestic' || this.pubFilterType === 'paper_overseas') {
            return this.getPublicationFilterCount(this.pubFilterType);
        }
        return this.getPublicationFilterCount('paper');
    }

    public get hasPaperPublicationFilter(): boolean {
        return ['paper', 'paper_domestic', 'paper_overseas'].includes(this.pubFilterType);
    }

    public get showReportManagerColumn(): boolean {
        if (this.pubFilterType === 'report') return true;
        return (this.publications || []).some((pub: any) => {
            const docType = String(pub?.doc_type || '').trim().toLowerCase();
            return docType === 'report' || docType === 'c';
        });
    }

    public getPublicationProjectManager(pub: any): string {
        const manager = String(pub?.pj_manager || '').trim();
        return manager || '-';
    }

    public getPublicationFilterCount(type: string): number {
        if (this.isYearFiltered && this.filteredStats) {
            if (type === 'all') return Number(this.filteredStats.total || 0);
            return Number(this.filteredStats[type] || 0);
        }

        if (type === 'all') {
            const count = Number(this.pubTypeCounts?.all);
            return Number.isFinite(count) && count >= 0 ? count : this.displayTotalPubs;
        }

        return Number(this.pubTypeCounts?.[type] || 0);
    }

    public async applyYearFilter() {
        if (this.isYearFiltered) {
            const { code, data } = await wiz.call("year_filtered_stats", {
                id: this.id,
                year_from: this.yearFrom || 0,
                year_to: this.yearTo || 0
            });
            if (code === 200) this.filteredStats = data;
        } else {
            this.filteredStats = null;
        }

        if (this.isYearFiltered) {
            const topRes = await wiz.call("top_publications", {
                id: this.id, limit: 5,
                year_from: this.yearFrom || 0,
                year_to: this.yearTo || 0
            });
            if (topRes.code === 200) this.topPubs = topRes.data;
        } else {
            const topRes = await wiz.call("top_publications", { id: this.id, limit: 5 });
            if (topRes.code === 200) this.topPubs = topRes.data;
        }

        await this.loadTab();
        if (this.showPubModal) {
            this.modalPubPage = 1;
            await this.loadModalPubs();
        }
        await this.service.render();
    }

    public async clearYearFilter() {
        this.yearFrom = 0;
        this.yearTo = 0;
        this.filteredStats = null;
        const topRes = await wiz.call("top_publications", { id: this.id, limit: 5 });
        if (topRes.code === 200) this.topPubs = topRes.data;
        await this.loadTab();
        if (this.showPubModal) {
            this.modalPubPage = 1;
            await this.loadModalPubs();
        }
        await this.service.render();
    }

    public async loadResearcher() {
        const { code, data } = await wiz.call("get", { id: this.id });
        if (code !== 200 || !data) {
            this.service.href('/search');
            return;
        }
        this.researcher = data;
    }

    public async loadTab() {
        if (this.tab === 'summary') {
            await this.loadSummary();
        } else if (this.tab === 'publications') {
            await this.loadPublications();
        } else if (this.tab === 'network') {
            await this.loadNetwork();
        } else if (this.tab === 'news') {
            await this.loadNews();
        } else if (this.tab === 'trend') {
            await this.loadTrend();
        }
    }

    public async loadSummary() {
        const topPubParams: any = { id: this.id, limit: 5 };
        if (this.isYearFiltered) {
            topPubParams.year_from = this.yearFrom || 0;
            topPubParams.year_to = this.yearTo || 0;
        }
        const [sumRes, topRes, statsRes, yearRes, coRes, orgRes] = await Promise.all([
            wiz.call("summary", { id: this.id }),
            wiz.call("top_publications", topPubParams),
            wiz.call("stats", { id: this.id }),
            wiz.call("yearly", { id: this.id }),
            wiz.call("coauthors", { id: this.id, limit: 5, scope: "all" }),
            wiz.call("related_orgs", { id: this.id, limit: 5, scope: "all" })
        ]);

        if (sumRes.code === 200) this.summary = sumRes.data;
        if (topRes.code === 200) this.topPubs = topRes.data;
        if (statsRes.code === 200) this.stats = statsRes.data;
        if (yearRes.code === 200) {
            this.yearlyData = yearRes.data;
            this.yearOptions = this.yearlyData.map(y => y.pub_year).sort((a, b) => a - b);
        }
        if (coRes.code === 200) this.topCoauthors = (coRes.data || []).slice(0, 5);
        if (orgRes.code === 200) this.relatedOrgs = orgRes.data || [];

        if (this.isYearFiltered) {
            const { code, data } = await wiz.call("year_filtered_stats", {
                id: this.id, year_from: this.yearFrom || 0, year_to: this.yearTo || 0
            });
            if (code === 200) this.filteredStats = data;
        }

        await this.service.render();
        setTimeout(() => this.renderSummaryCharts(), 50);
        this.loadResearchProfile();
        this.ensureTopicProfileLoaded();
    }

    public async loadResearchProfile() {
        const requestedId = this.id;
        const requestSeq = ++this.researchProfileRequestSeq;
        try {
            const { code, data } = await wiz.call("research_profile", { id: requestedId });
            if (requestedId !== this.id || requestSeq !== this.researchProfileRequestSeq) return;
            if (code === 200) {
                this.researchProfile = data;
                await this.service.render();
            }
        } catch (e) { }
    }

    public async ensureTopicProfileLoaded() {
        if (this.topicProfileLoading) return;
        if (this.topicProfileLoadedForId === this.id && this.topicProfile) {
            this.prepareKeywordClassificationView();
            this.topicProfileResolvedForId = this.id;
            return;
        }

        const requestedId = this.id;
        this.topicProfileLoading = true;
        this.topicProfileResolvedForId = '';
        await this.service.render();

        try {
            const { code, data } = await wiz.call("topic_profile", { id: requestedId });
            if (requestedId !== this.id) return;
            if (code === 200 && data) {
                this.topicProfile = data;
                this.prepareKeywordClassificationView();
                this.topicProfileLoadedForId = requestedId;
                await this.loadResearchProfile();
            }
        } catch (e) {
        } finally {
            if (requestedId !== this.id) return;
            this.topicProfileLoading = false;
            this.topicProfileResolvedForId = requestedId;
            await this.service.render();
        }
    }

    public async refreshTopicProfile() {
        const requestedId = this.id;
        this.topicProfileLoading = true;
        this.topicProfile = null;
        this.topicProfileLoadedForId = '';
        this.topicProfileResolvedForId = '';
        this.keywordClassificationVisibleCounts = {};
        this.resetKeywordClassificationView();
        await this.service.render();

        try {
            const { code, data } = await wiz.call("topic_profile", { id: requestedId, refresh: 'true' });
            if (requestedId !== this.id) return;
            if (code === 200 && data) {
                this.topicProfile = data;
                this.prepareKeywordClassificationView();
                this.topicProfileLoadedForId = requestedId;
                await this.loadResearchProfile();
            }
        } catch (e) {
        } finally {
            if (requestedId !== this.id) return;
            this.topicProfileLoading = false;
            this.topicProfileResolvedForId = requestedId;
            await this.service.render();
        }
    }

    public async loadPublications(page: number = 1) {
        this.pubPage = page;
        const params: any = {
            id: this.id, page: this.pubPage, dump: this.pubDump, sort: this.pubSort, order: this.pubSortOrder, doc_type: this.pubFilterType, search: this.pubSearchText
        };
        if (this.isYearFiltered) {
            params.year_from = this.yearFrom || 0;
            params.year_to = this.yearTo || 0;
        }
        const { code, data } = await wiz.call("publications", params);
        if (code === 200) {
            this.publications = data.rows;
            this.pubTotal = data.total;
            this.pubLastPage = Math.ceil(this.pubTotal / this.pubDump) || 1;
            if (data.type_counts) this.pubTypeCounts = data.type_counts;
        }
        await this.service.render();
    }

    public async loadNetwork() {
        this.coauthorPage = 1;
        this.relatedPage = 1;
        const [relRes, coRes, netRes, idxRes] = await Promise.all([
            wiz.call("related", { id: this.id }),
            wiz.call("coauthors", { id: this.id }),
            wiz.call("network", { id: this.id }),
            wiz.call("author_index_stats", { id: this.id })
        ]);

        if (relRes.code === 200) this.related = relRes.data;
        if (coRes.code === 200) this.coauthors = coRes.data;
        if (netRes.code === 200) {
            this.network = {
                nodes: netRes.data?.nodes || [],
                edges: netRes.data?.edges || []
            };
            this.networkMeta = netRes.data?.meta || null;
            this.collabThresholdFloor = Math.max(1, this.networkGraphCutoffCollaborationCount || 1);
            this.collabThreshold = this.normalizeCollabThreshold(this.collabThreshold);
        }
        if (idxRes.code === 200) this.authorIndexStats = idxRes.data;
        await this.service.render();
        setTimeout(() => this.drawNetworkGraph(), 50);
    }

    public async loadNews(forceRefresh: boolean = false) {
        this.newsLoading = true;
        this.newsArticles = [];
        this.hiddenNewsArticles = [];
        this.newsInsights = null;
        this.showHiddenNews = false;
        this.newsActivityFilter = '';
        this.normalArticlePage = 1;
        this.destroyNewsCharts();
        await this.service.render();

        let shouldCollect = forceRefresh;

        // 1) 캐시된 데이터 우선 로드 (빠른 응답)
        try {
            const params: any = { id: this.id };
            const { code, data } = await wiz.call("news_cached", params);
            if (code === 200 && data) {
                this.applyNewsPayload(data);
                shouldCollect = forceRefresh || !!data.should_collect_news;
                this.newsLoading = false;
                await this.service.render();
                if (this.newsInsights) {
                    setTimeout(() => this.renderNewsCharts(), 100);
                }
            }
        } catch (e) { }

        // 2) 수집 메타가 없거나 24시간 이상 지난 경우에만 RSS 갱신
        if (shouldCollect) {
            try {
                const params: any = { id: this.id };
                if (forceRefresh) params.force = 'true';
                const { code, data } = await wiz.call("news", params);
                if (code === 200 && data) {
                    this.applyNewsPayload(data);
                }
            } catch (e) { }
        }
        this.newsLoading = false;
        await this.service.render();
        if (this.newsInsights) {
            setTimeout(() => this.renderNewsCharts(), 100);
        }
    }

    private sortNewsArticles(rows: any[]): any[] {
        return [...(rows || [])].sort((left: any, right: any) => {
            const rightScore = Number(right?.score || 0);
            const leftScore = Number(left?.score || 0);
            if (rightScore !== leftScore) {
                return rightScore - leftScore;
            }

            const rightDate = String(right?.pub_date || right?.created || '');
            const leftDate = String(left?.pub_date || left?.created || '');
            return rightDate.localeCompare(leftDate);
        });
    }

    private applyNewsPayload(data: any) {
        this.newsInsights = data;
        this.newsArticles = this.sortNewsArticles(data?.articles || []);
        this.hiddenNewsArticles = this.sortNewsArticles(data?.hidden_articles || []);
        this.ensureNewsActivityFilter();
        this.normalArticlePage = 1;
        if (!this.isAdmin) {
            this.showHiddenNews = false;
        }
    }

    private destroyNewsCharts() {
        this.newsCharts.forEach(c => { try { c.destroy(); } catch {} });
        this.newsCharts = [];
    }

    private renderNewsCharts() {
        this.destroyNewsCharts();
        if (!this.newsInsights?.charts) return;

        // 활동 유형별 바 차트
        const byType = this.newsInsights.charts.by_type || [];
        if (byType.length > 0) {
            const el = document.getElementById('news-chart-type') as HTMLCanvasElement;
            if (el) {
                // 기존 차트가 있으면 명시적 파괴
                const existing = Chart.getChart(el);
                if (existing) existing.destroy();
                const colors = ['#3B82F6', '#22C55E', '#F59E0B', '#EF4444', '#8B5CF6', '#EC4899', '#6B7280'];
                this.newsCharts.push(new Chart(el, {
                    type: 'bar',
                    data: {
                        labels: byType.map((d: any) => d.type),
                        datasets: [{
                            label: '기사 수',
                            data: byType.map((d: any) => d.count),
                            backgroundColor: byType.map((_: any, i: number) => colors[i % colors.length]),
                            borderRadius: 6, barThickness: 32
                        }]
                    },
                    options: {
                        responsive: true, maintainAspectRatio: false,
                        plugins: { legend: { display: false } },
                        scales: { y: { beginAtZero: true, ticks: { stepSize: 1 } } }
                    }
                }));
            }
        }

        // 연도별 추이 차트
        const byPeriod = this.newsInsights.charts.by_period || [];
        if (byPeriod.length > 0) {
            const el = document.getElementById('news-chart-trend') as HTMLCanvasElement;
            if (el) {
                // 기존 차트가 있으면 명시적 파괴
                const existing = Chart.getChart(el);
                if (existing) existing.destroy();
                const allTypes = new Set<string>();
                byPeriod.forEach((p: any) => {
                    Object.keys(p).filter(k => k !== 'year').forEach(k => allTypes.add(k));
                });
                const typeArr = Array.from(allTypes);
                const colors = ['#3B82F6', '#22C55E', '#F59E0B', '#EF4444', '#8B5CF6', '#EC4899', '#6B7280'];
                const datasets = typeArr.map((t, i) => ({
                    label: t,
                    data: byPeriod.map((p: any) => p[t] || 0),
                    backgroundColor: colors[i % colors.length] + '99',
                    borderColor: colors[i % colors.length],
                    borderWidth: 1
                }));
                this.newsCharts.push(new Chart(el, {
                    type: 'bar',
                    data: { labels: byPeriod.map((p: any) => p.year), datasets },
                    options: {
                        responsive: true, maintainAspectRatio: false,
                        plugins: { legend: { position: 'bottom', labels: { boxWidth: 12, font: { size: 11 } } } },
                        scales: { x: { stacked: true }, y: { stacked: true, beginAtZero: true, ticks: { stepSize: 1 } } }
                    }
                }));
            }
        }
    }

    // ─── 연구 트렌드 ───
    public async loadTrend() {
        this.trendLoading = false;
        this.trendError = '';
        this.scholarData = null;
        this.trendData = null;
        this.scholarPubPage = 1;
        this.destroyTrendCharts();
        await this.service.render();
    }

    public async refreshScholar() {
        await this.loadTrend();
    }

    public get pagedScholarPubs(): any[] {
        if (!this.scholarData?.publications) return [];
        const start = (this.scholarPubPage - 1) * this.scholarPubDump;
        return this.scholarData.publications.slice(start, start + this.scholarPubDump);
    }

    public get scholarPubLastPage(): number {
        if (!this.scholarData?.publications) return 1;
        return Math.ceil(this.scholarData.publications.length / this.scholarPubDump) || 1;
    }

    public async scholarPubPageMove(page: number) {
        if (page < 1 || page > this.scholarPubLastPage) return;
        this.scholarPubPage = page;
        await this.service.render();
    }

    private destroyTrendCharts() {
        this.trendCharts.forEach(c => { try { c.destroy(); } catch {} });
        this.trendCharts = [];
    }

    private destroySummaryCharts() {
        this.summaryCharts.forEach(c => { try { c.destroy(); } catch {} });
        this.summaryCharts = [];
    }

    private renderSummaryCharts() {
        this.renderYearlyPublicationsChart();
    }

    private renderYearlyPublicationsChart() {
        this.destroySummaryCharts();

        const el = document.getElementById('yearly-publications-chart') as HTMLCanvasElement;
        if (!el || !this.filteredYearlyData?.length) return;

        const existing = Chart.getChart(el);
        if (existing) {
            try { existing.destroy(); } catch { }
        }

        const datasetMeta = [
            { key: 'paper', label: '논문', color: '#3B82F6', hover: '#3557b8' },
            { key: 'patent', label: '특허', color: '#F59E0B', hover: '#d97706' },
            { key: 'report', label: '보고서', color: '#22C55E', hover: '#16a34a' },
        ];
        const visibleMeta = this.yearlyCategoryView === 'all'
            ? datasetMeta
            : datasetMeta.filter((item: any) => item.key === this.yearlyCategoryView);

        this.summaryCharts.push(new Chart(el, {
            type: 'bar',
            data: {
                labels: this.filteredYearlyData.map((item: any) => item.pub_year),
                datasets: visibleMeta.map((item: any) => ({
                    label: item.label,
                    data: this.filteredYearlyData.map((yearItem: any) => Number(yearItem?.[item.key] || 0)),
                    backgroundColor: item.color,
                    hoverBackgroundColor: item.hover,
                    borderRadius: 8,
                    borderSkipped: false,
                    maxBarThickness: 24,
                    categoryPercentage: 0.74,
                    barPercentage: 0.82,
                }))
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                animation: false,
                plugins: {
                    legend: {
                        display: this.yearlyCategoryView === 'all',
                        position: 'top',
                        labels: {
                            boxWidth: 10,
                            boxHeight: 10,
                            usePointStyle: true,
                            pointStyle: 'rectRounded',
                        }
                    },
                    tooltip: {
                        callbacks: {
                            label: (ctx: any) => `${ctx.dataset.label} ${ctx.raw || 0}편`,
                        }
                    }
                },
                scales: {
                    x: {
                        grid: { display: false },
                        ticks: {
                            color: '#6b7280',
                            maxRotation: 0,
                            minRotation: 0,
                            autoSkip: true,
                            maxTicksLimit: 16,
                            font: { size: 11 },
                        },
                    },
                    y: {
                        beginAtZero: true,
                        ticks: { color: '#6b7280', stepSize: 1 },
                        grid: { color: 'rgba(148, 163, 184, 0.18)' },
                    }
                }
            }
        }));
    }

    private renderTrendCharts() {
        this.destroyTrendCharts();
        if (!this.trendData) return;
        const brandColors = ['#3B82F6', '#22C55E', '#F59E0B', '#EF4444', '#8B5CF6', '#EC4899', '#06B6D4', '#F97316', '#14B8A6', '#6366F1'];

        // 연도별 논문 수
        const yearlyEl = document.getElementById('trend-yearly-pubs') as HTMLCanvasElement;
        if (yearlyEl && this.trendData.yearly_pubs?.length) {
            this.trendCharts.push(new Chart(yearlyEl, {
                type: 'bar',
                data: {
                    labels: this.trendData.yearly_pubs.map((d: any) => d.year),
                    datasets: [{
                        label: '논문 수',
                        data: this.trendData.yearly_pubs.map((d: any) => d.count),
                        backgroundColor: '#3B82F6', borderRadius: 4, barThickness: 20
                    }]
                },
                options: {
                    responsive: true, maintainAspectRatio: false,
                    plugins: { legend: { display: false } },
                    scales: { y: { beginAtZero: true, ticks: { stepSize: 1 } } }
                }
            }));
        }

        // 키워드 빈도
        const kwEl = document.getElementById('trend-keyword-freq') as HTMLCanvasElement;
        if (kwEl && this.trendData.top_keywords?.length) {
            const kws = this.trendData.top_keywords.slice(0, 15);
            this.trendCharts.push(new Chart(kwEl, {
                type: 'bar',
                data: {
                    labels: kws.map((d: any) => d.keyword),
                    datasets: [{
                        label: '빈도',
                        data: kws.map((d: any) => d.count),
                        backgroundColor: brandColors.slice(0, kws.length).concat(brandColors),
                        borderRadius: 4, barThickness: 18
                    }]
                },
                options: {
                    indexAxis: 'y', responsive: true, maintainAspectRatio: false,
                    plugins: { legend: { display: false } },
                    scales: { x: { beginAtZero: true, ticks: { stepSize: 1 } } }
                }
            }));
        }

        // 키워드 트렌드 (line)
        const ktEl = document.getElementById('trend-keyword-trend') as HTMLCanvasElement;
        if (ktEl && this.trendData.keyword_trend?.length && this.trendData.keyword_labels?.length) {
            const labels = this.trendData.keyword_trend.map((d: any) => d.year);
            const datasets = this.trendData.keyword_labels.slice(0, 6).map((kw: string, i: number) => ({
                label: kw,
                data: this.trendData.keyword_trend.map((d: any) => d[kw] || 0),
                borderColor: brandColors[i % brandColors.length],
                backgroundColor: brandColors[i % brandColors.length] + '33',
                tension: 0.3, fill: false, pointRadius: 3, borderWidth: 2
            }));
            this.trendCharts.push(new Chart(ktEl, {
                type: 'line', data: { labels, datasets },
                options: {
                    responsive: true, maintainAspectRatio: false,
                    plugins: { legend: { position: 'bottom', labels: { boxWidth: 12, font: { size: 11 } } } },
                    scales: { y: { beginAtZero: true, ticks: { stepSize: 1 } } }
                }
            }));
        }

        // 인용 영향력
        const citEl = document.getElementById('trend-citation') as HTMLCanvasElement;
        if (citEl && this.trendData.citation_trend?.length) {
            this.trendCharts.push(new Chart(citEl, {
                type: 'line',
                data: {
                    labels: this.trendData.citation_trend.map((d: any) => d.year),
                    datasets: [{
                        label: '인용수',
                        data: this.trendData.citation_trend.map((d: any) => d.citations),
                        borderColor: '#8B5CF6', backgroundColor: '#8B5CF633',
                        tension: 0.3, fill: true, pointRadius: 3, borderWidth: 2
                    }]
                },
                options: {
                    responsive: true, maintainAspectRatio: false,
                    plugins: { legend: { display: false } },
                    scales: { y: { beginAtZero: true } }
                }
            }));
        }
    }

    public openScholarProfile() {
        if (this.scholarData?.scholar_id) {
            window.open(`https://scholar.google.com/citations?user=${this.scholarData.scholar_id}`, '_blank', 'noopener,noreferrer');
        }
    }

    public getYearlyChartMinWidth(): number {
        return Math.max(760, (this.filteredYearlyData?.length || 0) * 56);
    }

    public getTopicHeatmapTableMinWidth(): number {
        const topicWidth = 168;
        const yearCount = Math.max(this.topicHeatmapYears.length, 1);
        const yearWidth = yearCount > 24 ? 44 : 52;
        return topicWidth + (yearCount * yearWidth);
    }

    public getTopicHeatValue(topic: any, year: number): number {
        const key = String(year);
        return Number(topic?.year_counts?.[key] || 0);
    }

    public getTopicHeatCellStyle(value: number): any {
        const maxCount = Math.max(this.topicHeatmapMaxCount, 1);
        if (value <= 0) {
            return {
                backgroundColor: '#f5f7fb',
                color: '#94a3b8',
                borderColor: 'rgba(148, 163, 184, 0.12)',
            };
        }

        const ratio = value / maxCount;
        const alpha = Math.min(0.9, 0.18 + ratio * 0.62);
        return {
            backgroundColor: `rgba(74, 111, 216, ${alpha})`,
            color: ratio >= 0.45 ? '#ffffff' : '#1f2937',
            borderColor: 'rgba(74, 111, 216, 0.18)',
        };
    }

    public getTopicKeywordPreview(topic: any): string {
        const keywords = Array.isArray(topic?.keywords) ? topic.keywords : [];
        return keywords.slice(0, 4).join(' · ');
    }

    public getTopicKeywordShort(topic: any): string {
        const actualKeywords = this.getTopicPublicationKeywordItems(topic, 3).map((item: any) => item.display);
        return actualKeywords.join(' · ');
    }

    public getTopicKeywordCount(topic: any): number {
        return this.getTopicPublicationKeywordItems(topic, 80).length;
    }

    public hasMoreTopicKeywords(topic: any): boolean {
        return this.getTopicPublicationKeywordItems(topic, 80).length > 3;
    }

    public getTopicKeywordFull(topic: any): string {
        const actualKeywords = this.getTopicPublicationKeywordItems(topic, 80).map((item: any) => item.display);
        return actualKeywords.slice(3).join(' · ');
    }

    private getTopicKeywordList(topic: any): string[] {
        const keywords = Array.isArray(topic?.keywords) ? topic.keywords : [];
        const seen = new Set<string>();
        const result: string[] = [];
        keywords.forEach((keyword: any) => {
            const text = String(keyword || '').trim();
            const key = this.normalizeKeywordTerm(text);
            if (!text || !key || seen.has(key)) return;
            seen.add(key);
            result.push(text);
        });
        return result;
    }

    private formatRelatedTopicItem(item: any): any {
        const source = typeof item === 'string' ? { keyword: item, display: item, keywords: [item] } : item;
        const keywords = Array.isArray(source?.keywords)
            ? source.keywords.map((kw: any) => String(kw || '').trim()).filter((kw: string) => kw)
            : [];
        const display = String(source?.display || keywords.join(' · ') || source?.keyword || '').trim();
        if (!display) return null;
        return {
            display,
            keywords,
            count: Number(source?.count || 0),
            lang: source?.lang || '',
            domestic: source?.domestic || 'N',
            is_korean_keyword: source?.is_korean_keyword === true,
        };
    }

    private normalizeRelatedTopicItems(items: any[]): any[] {
        const seen = new Set<string>();
        const result: any[] = [];

        (items || []).forEach((item: any) => {
            const formatted = this.formatRelatedTopicItem(item);
            if (!formatted?.display) return;
            const keywordKey = Array.isArray(formatted.keywords) && formatted.keywords.length > 0
                ? formatted.keywords.map((keyword: string) => this.normalizeKeywordTerm(keyword)).filter((keyword: string) => keyword).join('|')
                : '';
            const key = keywordKey || this.normalizeKeywordTerm(formatted.display);
            if (!key || seen.has(key)) return;
            seen.add(key);
            result.push(formatted);
        });

        return result;
    }

    public getTopicPublicationKeywordItems(topic: any, limit: number = 80, year?: number): any[] {
        if (year) {
            const yearKey = String(year);
            const publicationItems = Array.isArray(topic?.year_publication_keywords?.[yearKey])
                ? topic.year_publication_keywords[yearKey]
                : [];
            const yearItems = this.preferKoreanKeywordItems(this.normalizeRelatedTopicItems(publicationItems), limit);
            if (yearItems.length > 0) return yearItems;

            return [];
        }

        const directSource = Array.isArray(topic?.publication_keywords) ? topic.publication_keywords : [];
        const directItems = this.preferKoreanKeywordItems(this.normalizeRelatedTopicItems(directSource), limit);
        if (directItems.length > 0) return directItems;
        return [];
    }

    private getSummaryKeywordCount(keyword: string): number {
        const key = this.normalizeKeywordTerm(keyword);
        if (!key) return 0;
        const rows = Array.isArray(this.summary?.top_keywords) ? this.summary.top_keywords : [];
        const found = rows.find((item: any) => this.normalizeKeywordTerm(item?.keyword || item?.display || '') === key);
        return Number(found?.count || 0);
    }

    private getTopicKeywordDisplayLimit(group: any, keywords: string[] = [], fallbackLimit: number = 8): number {
        const groupCount = Number(group?.count || group?.filtered_total || 0);
        if (Number.isFinite(groupCount) && groupCount > 0) {
            return Math.max(1, Math.min(80, Math.floor(groupCount)));
        }

        const counts = [
            ...keywords.map((keyword: string) => this.getSummaryKeywordCount(keyword)),
        ].filter((count: number) => Number.isFinite(count) && count > 0);
        const limit = counts.length > 0 ? Math.max(...counts) : fallbackLimit;
        return Math.max(1, Math.min(80, Math.floor(limit)));
    }

    private getPrimaryRelatedKeywordLimit(): number {
        const rows = Array.isArray(this.summary?.top_keywords) ? this.summary.top_keywords : [];
        const topCount = Number(rows[0]?.count || 0);
        return Math.max(1, Math.min(80, Math.floor(topCount || this.getMainTopicCount() || 8)));
    }

    private getSummaryKeywordItems(excludedKeywords: string[] = [], limit: number = 40): any[] {
        const excluded = new Set(
            excludedKeywords
                .map((kw: string) => this.normalizeKeywordTerm(kw))
                .filter((kw: string) => kw)
        );
        const seen = new Set<string>();
        const rows = Array.isArray(this.summary?.top_keywords) ? this.summary.top_keywords : [];

        const items = rows
            .map((item: any) => {
                const display = String(item?.keyword || item?.display || '').trim();
                const key = this.normalizeKeywordTerm(display);
                if (!display || !key || excluded.has(key) || seen.has(key)) return null;
                seen.add(key);
                return {
                    display,
                    keywords: [display],
                    count: Number(item?.count || 0),
                };
            })
            .filter((item: any) => item?.display);
        return this.preferKoreanKeywordItems(items, limit);
    }

    private getRelatedItemsForKeywords(keywords: string[], limit: number = 80): any[] {
        const keySet = new Set(keywords.map((kw: string) => this.normalizeKeywordTerm(kw)).filter((kw: string) => kw));
        if (keySet.size === 0) return this.getSummaryKeywordItems([], limit);

        const relatedRows = Array.isArray(this.topicProfile?.related_keywords) ? this.topicProfile.related_keywords : [];
        const seen = new Set<string>();
        const related = relatedRows
            .filter((item: any) => {
                const pairKeywords = Array.isArray(item?.keywords) ? item.keywords : [];
                return pairKeywords.some((kw: any) => keySet.has(this.normalizeKeywordTerm(kw)));
            })
            .map((item: any) => this.formatRelatedTopicItem(item))
            .filter((item: any) => {
                if (!item?.display) return false;
                const key = this.normalizeKeywordTerm(item.display);
                if (!key || seen.has(key)) return false;
                seen.add(key);
                return true;
            });

        if (related.length > 0) return related;

        return this.getSummaryKeywordItems(keywords, limit);
    }

    private buildTopicKeywordGroup(group: any, options: any = {}): any {
        const actualOnly = !!options?.actualOnly;
        const keywords = actualOnly ? [] : this.getTopicKeywordList(group);
        const limit = this.getTopicKeywordDisplayLimit(group, keywords);
        const directRelatedSource = Array.isArray(group?.publication_keywords) ? group.publication_keywords : [];
        const directRelated = this.preferKoreanKeywordItems(this.normalizeRelatedTopicItems(directRelatedSource), limit);
        let related = directRelated;
        if (!actualOnly && related.length === 0) {
            related = this.getRelatedItemsForKeywords(keywords, limit);
        }
        related = related.slice(0, limit);
        return {
            label: group?.label || group?.topic || '토픽',
            count: Number(group?.count || group?.filtered_total || 0),
            keywords,
            related,
        };
    }

    public getRelatedTopicKeywords(): string[] {
        const groups = this.getRelatedTopicKeywordGroups();
        if (groups.length > 0) {
            const seen = new Set<string>();
            const result: string[] = [];
            for (const group of groups) {
                const values = [
                    ...(Array.isArray(group.keywords) ? group.keywords : []),
                    ...(Array.isArray(group.related) ? group.related.map((item: any) => item?.display || '') : []),
                ];
                for (const value of values) {
                    const text = String(value || '').trim();
                    const key = this.normalizeKeywordTerm(text);
                    if (!text || !key || seen.has(key)) continue;
                    seen.add(key);
                    result.push(text);
                }
            }
            return result.slice(0, 80);
        }

        const seen = new Set<string>();
        const result: string[] = [];
        const addKeyword = (value: any) => {
            let text = '';
            if (typeof value === 'string') {
                text = value;
            } else if (value?.display) {
                text = String(value.display || '');
                if (value.count) text = `${text} (${value.count}건)`;
            } else if (Array.isArray(value?.keywords)) {
                text = value.keywords.map((kw: any) => String(kw || '').trim()).filter((kw: string) => kw).join(' · ');
                if (value.count) text = `${text} (${value.count}건)`;
            } else {
                text = String(value?.keyword || '').trim();
            }
            text = String(text || '').trim();
            const key = this.normalizeKeywordTerm(text);
            if (!text || !key || seen.has(key)) return;
            seen.add(key);
            result.push(text);
        };

        const relatedKeywords = this.topicProfile?.related_keywords || [];
        if (Array.isArray(relatedKeywords)) {
            relatedKeywords.forEach(addKeyword);
        }
        if (result.length > 0) {
            return result.slice(0, 80);
        }

        const rows = this.topicHeatmapRows || [];
        rows.forEach((topic: any) => {
            if (Array.isArray(topic?.keywords)) {
                topic.keywords.forEach(addKeyword);
            }
        });

        const topKeywords = this.summary?.top_keywords || [];
        topKeywords.forEach(addKeyword);

        return result.slice(0, 80);
    }

    public getRelatedTopicKeywordGroups(): any[] {
        const relatedRows = Array.isArray(this.topicProfile?.related_keywords) ? this.topicProfile.related_keywords : [];
        const relatedGroupRows = Array.isArray(this.topicProfile?.related_keyword_groups) ? this.topicProfile.related_keyword_groups : [];
        const heatmapRows = Array.isArray(this.topicProfile?.topic_heatmap) ? this.topicProfile.topic_heatmap : [];
        const hasMappedRelated = relatedRows.length > 0 || relatedGroupRows.some((group: any) => {
            return (Array.isArray(group?.publication_keywords) && group.publication_keywords.length > 0)
                || (Array.isArray(group?.related) && group.related.length > 0);
        }) || heatmapRows.some((group: any) => {
            return (Array.isArray(group?.publication_keywords) && group.publication_keywords.length > 0)
                || (Array.isArray(group?.related) && group.related.length > 0)
                || (Array.isArray(group?.related_keywords) && group.related_keywords.length > 0);
        });

        if (!hasMappedRelated) {
            const summaryLimit = this.getPrimaryRelatedKeywordLimit();
            const summaryItems = this.getSummaryKeywordItems([], summaryLimit);
            if (summaryItems.length > 0) {
                return [{
                    label: '대표키워드',
                    count: summaryLimit,
                    keywords: [],
                    related: summaryItems,
                }];
            }
        }

        const sourceGroups = Array.isArray(this.topicProfile?.related_keyword_groups) && this.topicProfile.related_keyword_groups.length > 0
            ? this.topicProfile.related_keyword_groups
            : this.topicHeatmapRows;

        const groups = (sourceGroups || [])
            .map((group: any) => this.buildTopicKeywordGroup(group))
            .filter((group: any) => group.keywords.length > 0 || group.related.length > 0);

        if (groups.length > 0) return groups;

        if (relatedRows.length > 0) {
            return [{
                label: '공출현 키워드',
                count: 0,
                keywords: [],
                related: relatedRows
                    .map((item: any) => ({
                        display: this.formatRelatedTopicItem(item)?.display || '',
                        count: Number(item?.count || 0),
                    }))
                    .filter((item: any) => item.display),
            }];
        }

        return [];
    }

    public getRelatedTopicKeywordCard(): any {
        return {
            label: '관련 키워드',
            groups: this.getRelatedTopicKeywordGroups(),
            keywords: this.getRelatedTopicKeywords(),
        };
    }

    public getTopicKeywordCard(topic: any): any {
        const group = this.buildTopicKeywordGroup(topic, { actualOnly: true });
        return {
            ...topic,
            label: group.label,
            keywords: group.keywords,
            groups: group.keywords.length > 0 || group.related.length > 0 ? [group] : [],
        };
    }

    public getTopicKeywordGroupDisplayCount(group: any): number {
        const keywordCount = Array.isArray(group?.keywords) ? group.keywords.length : 0;
        const relatedCount = Array.isArray(group?.related) ? group.related.length : 0;
        return relatedCount > 0 ? relatedCount : keywordCount;
    }

    public isTopicKeywordsExpanded(topic: any): boolean {
        return this.expandedTopicLabels.has(topic?.label || '');
    }

    public async toggleTopicKeywords(topic: any) {
        const label = topic?.label || '';
        if (this.expandedTopicLabels.has(label)) {
            this.expandedTopicLabels.delete(label);
        } else {
            this.expandedTopicLabels.add(label);
        }
        await this.service.render();
    }

    public async openTopicKeywordCard(event: any, topic: any) {
        event.stopPropagation();
        this.topicHeatmapTooltip = null;
        if (this.topicKeywordCard?.label === topic.label) {
            this.topicKeywordCard = null;
        } else {
            this.topicKeywordCard = topic;
            const trigger = event.currentTarget as HTMLElement;
            const panel = trigger?.closest('.topic-heatmap-panel') as HTMLElement;
            if (trigger && panel) {
                const triggerRect = trigger.getBoundingClientRect();
                const panelRect = panel.getBoundingClientRect();
                const popoverWidth = Math.min(360, Math.max(260, panelRect.width - 16));
                const maxLeft = Math.max(8, panelRect.width - popoverWidth - 8);
                const left = triggerRect.left - panelRect.left;
                this.topicKeywordCardPos = {
                    top: Math.max(8, triggerRect.bottom - panelRect.top + 6),
                    left: Math.min(Math.max(left, 8), maxLeft),
                };
            } else {
                this.topicKeywordCardPos = { top: 8, left: 8 };
            }
        }
        await this.service.render();
    }

    public async closeTopicKeywordCard() {
        this.topicKeywordCard = null;
        await this.service.render();
    }

    public getTopicSourceLabel(): string {
        if (this.topicProfile?.topic_source === 'ai') {
            return 'AI 자동 토픽 추출';
        }
        return '키워드 자동 묶음';
    }

    public get normalArticles(): any[] {
        const rows = this.sortNewsArticles(this.newsArticles);
        if (!this.newsActivityFilter) return rows;
        return rows.filter((article: any) => this.getNewsActivityType(article) === this.newsActivityFilter);
    }

    public get newsActivityOptions(): any[] {
        const counts = new Map<string, number>();
        (this.newsArticles || []).forEach((article: any) => {
            const type = this.getNewsActivityType(article);
            if (!type) return;
            counts.set(type, (counts.get(type) || 0) + 1);
        });
        return Array.from(counts.entries())
            .map(([type, count]) => ({ type, count }))
            .sort((left: any, right: any) => {
                if (right.count !== left.count) return right.count - left.count;
                return String(left.type).localeCompare(String(right.type), 'ko');
            });
    }

    private getNewsActivityType(article: any): string {
        return String(article?.activity_type || '').trim();
    }

    private ensureNewsActivityFilter() {
        if (!this.newsActivityFilter) return;
        const exists = this.newsActivityOptions.some((option: any) => option.type === this.newsActivityFilter);
        if (!exists) {
            this.newsActivityFilter = '';
        }
    }

    public get pagedNormalArticles(): any[] {
        const start = (this.normalArticlePage - 1) * this.normalArticleDump;
        return this.normalArticles.slice(start, start + this.normalArticleDump);
    }

    public get normalArticleLastPage(): number {
        return Math.ceil(this.normalArticles.length / this.normalArticleDump) || 1;
    }

    public async changeNewsActivityFilter(type: string) {
        this.newsActivityFilter = type || '';
        this.normalArticlePage = 1;
        await this.service.render();
    }

    public isNewsActionLoading(articleId: string): boolean {
        return this.newsActionLoadingIds.has(articleId);
    }

    public async toggleHiddenNewsView() {
        if (!this.isAdmin) return;
        this.showHiddenNews = !this.showHiddenNews;
        await this.service.render();
    }

    public async setNewsVisibility(article: any, hidden: boolean) {
        if (!this.isAdmin || !article?.id) return;

        this.newsActionLoadingIds.add(article.id);
        await this.service.render();

        try {
            const { code } = await wiz.call("set_news_visibility", {
                researcher_id: this.id,
                article_id: article.id,
                hidden: hidden ? 'true' : 'false',
            });

            if (code === 200) {
                const params: any = { id: this.id };
                const cachedRes = await wiz.call("news_cached", params);
                if (cachedRes.code === 200 && cachedRes.data) {
                    this.applyNewsPayload(cachedRes.data);
                }
            }
        } catch (e) { }

        this.newsActionLoadingIds.delete(article.id);
        await this.service.render();
        if (this.newsInsights) {
            setTimeout(() => this.renderNewsCharts(), 50);
        }
    }

    public async normalArticlePageMove(page: number) {
        if (page < 1 || page > this.normalArticleLastPage) return;
        this.normalArticlePage = page;
        await this.service.render();
    }

    // ─── 네트워크 탭 페이지네이션 ───
    public get pagedCoauthors(): any[] {
        const start = (this.coauthorPage - 1) * this.netPageSize;
        return this.coauthors.slice(start, start + this.netPageSize);
    }

    public get coauthorTotalPages(): number {
        return Math.ceil(this.coauthors.length / this.netPageSize) || 1;
    }

    public get networkGraphLimit(): number {
        return this.networkMeta?.graph_limit || 0;
    }

    public get networkCandidateCount(): number {
        if (this.networkMeta?.graph_candidate_count) {
            return this.networkMeta.graph_candidate_count;
        }
        return Math.max((this.network?.nodes?.length || 1) - 1, 0);
    }

    private toNetworkCount(value: any): number {
        const count = Math.floor(Number(value) || 0);
        return Math.max(0, count);
    }

    private getCollaborationCountValue(item: any): number {
        const researcher = item?.researcher || {};
        return this.toNetworkCount(
            item?.collaboration_count
            ?? item?.output_count
            ?? item?.publication_count
            ?? item?.count
            ?? researcher?.collaboration_count
            ?? researcher?.output_count
            ?? researcher?.publication_count
            ?? researcher?.count
            ?? item?.paper_count
            ?? researcher?.paper_count
            ?? item?.weight
        );
    }

    private getNetworkCollabCountMap(): Map<string, number> {
        const counts = new Map<string, number>();
        const centerId = this.id;

        for (const node of this.network?.nodes || []) {
            if (!node?.id || node.id === centerId || node.is_center) continue;
            const count = this.getCollaborationCountValue(node);
            if (count > 0) counts.set(node.id, count);
        }

        for (const edge of this.network?.edges || []) {
            const source = edge?.source;
            const target = edge?.target;
            const nodeId = source === centerId ? target : (target === centerId ? source : '');
            if (!nodeId || counts.get(nodeId)) continue;
            counts.set(nodeId, this.getCollaborationCountValue(edge));
        }

        return counts;
    }

    private getNetworkNodeCollabCount(node: any, countMap?: Map<string, number>): number {
        if (!node || node.is_center) return 0;
        const counts = countMap || this.getNetworkCollabCountMap();
        return counts.get(node.id) || this.getCollaborationCountValue(node);
    }

    private getVisibleNetworkNodeIds(): Set<string> {
        const visibleIds = new Set<string>([this.id]);
        const threshold = this.effectiveCollabThreshold;
        const countMap = this.getNetworkCollabCountMap();

        for (const node of this.network?.nodes || []) {
            if (!node?.id || node.id === this.id || node.is_center) continue;
            if (this.getNetworkNodeCollabCount(node, countMap) >= threshold) {
                visibleIds.add(node.id);
            }
        }

        return visibleIds;
    }

    public get effectiveCollabThreshold(): number {
        return this.normalizeCollabThreshold(this.collabThreshold);
    }

    private get networkCandidateCoauthors(): any[] {
        const candidateCount = this.networkCandidateCount;
        if (candidateCount <= 0) return [];
        return this.coauthors.slice(0, candidateCount);
    }

    public get hasNetworkLimitNotice(): boolean {
        return this.coauthors.length > this.networkCandidateCount;
    }

    public get networkVisibleNodeCount(): number {
        return this.getVisibleNetworkNodeIds().size;
    }

    public get networkVisibleCoauthorCount(): number {
        return Math.max(this.networkVisibleNodeCount - 1, 0);
    }

    public get networkGraphCutoffCollaborationCount(): number {
        const candidates = this.networkCandidateCoauthors;
        if (candidates.length === 0) return 0;
        return this.getCollaborationCountValue(candidates[candidates.length - 1]);
    }

    public get networkGraphCutoffPaperCount(): number {
        return this.networkGraphCutoffCollaborationCount;
    }

    public get networkVisibleMinCollaborationCount(): number {
        const visibleIds = this.getVisibleNetworkNodeIds();
        const counts = this.networkCandidateCoauthors
            .filter((co: any) => visibleIds.has(co.researcher_id))
            .map((co: any) => this.getCollaborationCountValue(co))
            .filter((count: number) => count > 0);

        if (counts.length === 0) return 0;
        return Math.min(...counts);
    }

    public get networkVisibleMinPaperCount(): number {
        return this.networkVisibleMinCollaborationCount;
    }

    public get networkThresholdFilteredCount(): number {
        if (!this.network?.nodes?.length) return 0;

        const visiblePeripheralCount = Array.from(this.getVisibleNetworkNodeIds())
            .filter((nodeId: string) => nodeId !== this.id).length;
        return Math.max(this.networkCandidateCount - visiblePeripheralCount, 0);
    }

    public async coauthorPageMove(delta: number) {
        const next = this.coauthorPage + delta;
        if (next < 1 || next > this.coauthorTotalPages) return;
        this.coauthorPage = next;
        await this.service.render();
    }

    public get pagedRelated(): any[] {
        const start = (this.relatedPage - 1) * this.netPageSize;
        return this.related.slice(start, start + this.netPageSize);
    }

    public get relatedTotalPages(): number {
        return Math.ceil(this.related.length / this.netPageSize) || 1;
    }

    public async relatedPageMove(delta: number) {
        const next = this.relatedPage + delta;
        if (next < 1 || next > this.relatedTotalPages) return;
        this.relatedPage = next;
        await this.service.render();
    }

    public async changeYearlyCategoryView(view: string) {
        if (this.yearlyCategoryView === view) return;
        this.yearlyCategoryView = view;
        await this.service.render();
        setTimeout(() => this.renderSummaryCharts(), 50);
    }

    public getYearlyCategoryButtonClass(view: string): string {
        if (this.yearlyCategoryView === view) {
            if (view === 'paper') return 'bg-blue-600 text-white border-blue-600';
            if (view === 'report') return 'bg-green-600 text-white border-green-600';
            if (view === 'patent') return 'bg-amber-500 text-white border-amber-500';
            return 'bg-[#4A6FD8] text-white border-[#4A6FD8]';
        }
        return 'bg-white text-zinc-600 border-zinc-200 hover:border-zinc-300';
    }

    // ─── 성과물 모달 ───
    public async openPubModal(type: string) {
        this.modalPubRootType = type;
        this.modalPubType = type;
        this.modalPubPage = 1;
        this.showPubModal = true;
        this.modalPubLoading = true;
        await this.service.render();
        await this.loadModalPubs();
    }

    public async closePubModal() {
        this.showPubModal = false;
        this.modalPubRootType = '';
        this.modalPubs = [];
        await this.service.render();
    }

    public get showModalPaperTabs(): boolean {
        return this.modalPubRootType === 'paper' && this.hasOverseasPapers;
    }

    public getModalPaperCount(type: string): number {
        if (type === 'paper') return this.displayPaperCnt;
        if (type === 'paper_domestic') return this.displayDomesticPaperCnt;
        if (type === 'paper_overseas') return this.displayOverseasPaperCnt;
        return 0;
    }

    public async switchModalPubType(type: string) {
        if (this.modalPubType === type) return;
        this.modalPubType = type;
        this.modalPubPage = 1;
        await this.loadModalPubs();
    }

    private async loadModalPubs() {
        this.modalPubLoading = true;
        await this.service.render();
        const params: any = {
            id: this.id, page: this.modalPubPage, dump: this.modalPubDump, sort: 'pub_year', doc_type: this.modalPubType
        };
        if (this.isYearFiltered) {
            params.year_from = this.yearFrom || 0;
            params.year_to = this.yearTo || 0;
        }
        const { code, data } = await wiz.call("publications", params);
        if (code === 200) {
            this.modalPubs = data.rows;
            this.modalPubTotal = data.total;
            this.modalPubLastPage = Math.ceil(this.modalPubTotal / this.modalPubDump) || 1;
        }
        this.modalPubLoading = false;
        await this.service.render();
    }

    public async modalPubPageMove(page: number) {
        this.modalPubPage = page;
        await this.loadModalPubs();
    }

    // ─── 공동 성과 모달 ───
    private emptyCollabTypeCounts(): any {
        return { all: 0, paper: 0, paper_domestic: 0, paper_overseas: 0, report: 0, patent: 0 };
    }

    private normalizeCollaborator(item: any): any {
        const researcher = item?.researcher || {};
        const researcherId = item?.researcher_id || researcher?.researcher_id || item?.id || '';
        const collaborationCount = this.getCollaborationCountValue(item);
        return {
            ...researcher,
            researcher_id: researcherId,
            name_kor: researcher?.name_kor || item?.name_kor || item?.name || '',
            name_eng: researcher?.name_eng || item?.name_eng || '',
            org_name: researcher?.org_name || item?.org_name || '',
            org_id: researcher?.org_id || item?.org_id || '',
            collaboration_count: collaborationCount,
            output_count: collaborationCount,
            publication_count: collaborationCount,
            paper_count: collaborationCount
        };
    }

    public async openCollabModal(item: any) {
        const coauthor = this.normalizeCollaborator(item);
        if (!coauthor.researcher_id) return;

        this.collabModalCoauthor = coauthor;
        this.collabModalType = '';
        this.collabModalPaperType = 'paper';
        this.collabModalPage = 1;
        this.collabTypeCounts = this.emptyCollabTypeCounts();
        this.collabModalPubs = [];
        this.collabModalTotal = 0;
        this.collabModalLastPage = 1;
        this.showCollabModal = true;
        this.collabModalLoading = true;
        await this.service.render();
        await this.loadCollabModalPubs();
    }

    public async closeCollabModal() {
        this.showCollabModal = false;
        this.collabModalCoauthor = null;
        this.collabModalPubs = [];
        this.collabModalType = '';
        this.collabModalPaperType = 'paper';
        this.collabTypeCounts = this.emptyCollabTypeCounts();
        await this.service.render();
    }

    private getCollabModalDocType(): string {
        if (this.collabModalType === 'paper') {
            return this.collabModalPaperType || 'paper';
        }
        return this.collabModalType;
    }

    private async loadCollabModalPubs() {
        if (!this.collabModalCoauthor?.researcher_id) return;

        this.collabModalLoading = true;
        await this.service.render();
        const { code, data } = await wiz.call("coauthor_publications", {
            id: this.id,
            coauthor_id: this.collabModalCoauthor.researcher_id,
            page: this.collabModalPage,
            dump: this.collabModalDump,
            sort: 'pub_year',
            order: 'DESC',
            doc_type: this.getCollabModalDocType()
        });
        if (code === 200) {
            this.collabModalPubs = data.rows || [];
            this.collabModalTotal = data.total || 0;
            this.collabTypeCounts = { ...this.emptyCollabTypeCounts(), ...(data.type_counts || {}) };
            this.collabModalLastPage = Math.ceil(this.collabModalTotal / this.collabModalDump) || 1;
        } else {
            this.collabModalPubs = [];
            this.collabModalTotal = 0;
            this.collabModalLastPage = 1;
        }
        this.collabModalLoading = false;
        await this.service.render();
    }

    public async switchCollabModalType(type: string) {
        if (this.collabModalType === type) return;
        this.collabModalType = type;
        if (type === 'paper' && !this.collabModalPaperType) {
            this.collabModalPaperType = 'paper';
        }
        this.collabModalPage = 1;
        await this.loadCollabModalPubs();
    }

    public async switchCollabModalPaperType(type: string) {
        const nextType = type || 'paper';
        if (this.collabModalType === 'paper' && this.collabModalPaperType === nextType) return;
        this.collabModalType = 'paper';
        this.collabModalPaperType = nextType;
        this.collabModalPage = 1;
        await this.loadCollabModalPubs();
    }

    public async collabModalPageMove(page: number) {
        this.collabModalPage = page;
        await this.loadCollabModalPubs();
    }

    public getCollabTypeCount(type: string): number {
        const key = type || 'all';
        return Number(this.collabTypeCounts?.[key] || 0);
    }

    public getCollabModalTitle(): string {
        const name = this.collabModalCoauthor?.name_kor || this.collabModalCoauthor?.name_eng || '선택한 연구자';
        return `${name} 연구자와의 공동 성과`;
    }

    public async goCollabResearcherProfile() {
        const researcherId = this.collabModalCoauthor?.researcher_id;
        if (!researcherId) return;
        this.showCollabModal = false;
        this.collabModalPubs = [];
        await this.service.render();
        this.service.href(`/researcher/${researcherId}`);
    }

    // ─── 네트워크 그래프 ───
    private drawNetworkGraph() {
        const canvas = document.getElementById('networkCanvas') as HTMLCanvasElement;
        if (!canvas || !this.network || !this.network.nodes || this.network.nodes.length < 2) return;
        const ctx = canvas.getContext('2d');
        if (!ctx) return;

        const container = canvas.parentElement;
        const graphHeight = 420;
        const dpr = Math.max(window.devicePixelRatio || 1, 1);
        const graphWidth = Math.max(320, container?.clientWidth || canvas.clientWidth || canvas.width);
        canvas.style.height = `${graphHeight}px`;
        canvas.width = Math.round(graphWidth * dpr);
        canvas.height = Math.round(graphHeight * dpr);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

        const W = graphWidth;
        const H = graphHeight;
        const cx = W / 2;
        const cy = H / 2;

        const centerId = this.id;
        const collabCountMap = this.getNetworkCollabCountMap();
        const peripheralCounts = (this.network.nodes || [])
            .filter((node: any) => node?.id && node.id !== centerId && !node.is_center)
            .map((node: any) => this.getNetworkNodeCollabCount(node, collabCountMap))
            .filter((count: number) => count > 0);
        const minCollabCount = peripheralCounts.length > 0 ? Math.min(...peripheralCounts) : 0;
        const maxCollabCount = peripheralCounts.length > 0 ? Math.max(...peripheralCounts) : 1;

        const getNodeScaleRatio = (collabCount: number) => {
            if (maxCollabCount <= minCollabCount) return collabCount > 0 ? 0.5 : 0;
            const normalized = Math.min(Math.max((collabCount - minCollabCount) / (maxCollabCount - minCollabCount), 0), 1);
            return Math.pow(normalized, 1.25);
        };

        // 주변 노드 색상: 남색(navy) 계열 그라데이션
        const getNodeColor = (collabCount: number) => {
            const t = getNodeScaleRatio(collabCount);
            // 밝은 남색 → 진한 남색 그라데이션
            const r = Math.round(152 - t * 112);
            const g = Math.round(174 - t * 116);
            const b = Math.round(222 - t * 52);
            return `rgb(${r},${g},${b})`;
        };
        const getNodeRadius = (collabCount: number) => {
            if (maxCollabCount <= minCollabCount) return collabCount > 0 ? 30 : 14;
            const t = getNodeScaleRatio(collabCount);
            return Math.max(14, Math.min(14 + t * 28, 42));
        };

        const nodes = this.network.nodes.map((n: any, i: number) => {
            const collabCount = this.getNetworkNodeCollabCount(n, collabCountMap);
            const outputCount = this.getCollaborationCountValue(n) || collabCount;
            const r = n.is_center ? 18 : getNodeRadius(collabCount);
            if (n.is_center) return {
                ...n,
                x: cx,
                y: cy,
                vx: 0,
                vy: 0,
                r,
                collabCount,
                ws: collabCount,
                collaboration_count: outputCount,
                output_count: outputCount,
                publication_count: outputCount,
                paper_count: outputCount
            };
            const angle = (2 * Math.PI * i) / this.network.nodes.length;
            const dist = 140 + Math.random() * 60;
            return {
                ...n,
                x: cx + dist * Math.cos(angle),
                y: cy + dist * Math.sin(angle),
                vx: 0,
                vy: 0,
                r,
                collabCount,
                ws: collabCount,
                collaboration_count: outputCount,
                output_count: outputCount,
                publication_count: outputCount,
                paper_count: outputCount
            };
        });
        const visibleNodeIds = this.getVisibleNetworkNodeIds();
        const edges = this.network.edges.map((e: any) => ({
            source: nodes.find((n: any) => n.id === e.source),
            target: nodes.find((n: any) => n.id === e.target),
            weight: e.weight || 1,
            isCenterEdge: e.source === this.id || e.target === this.id,
        })).filter((e: any) => e.source && e.target && visibleNodeIds.has(e.source.id) && visibleNodeIds.has(e.target.id) && e.weight >= this.effectiveCollabThreshold);

        // 중심 연구자와의 공동연구 수가 필터 기준 이상인 노드만 표시
        const visibleNodes = nodes.filter((n: any) => visibleNodeIds.has(n.id));

        const maxW = Math.max(...edges.map((e: any) => e.weight), 1);

        const centerColor = '#E8952F';
        const brandColor = '#4A6FD8';
        const edgeWeightRatio = (weight: number) => Math.min(Math.max(weight / maxW, 0), 1);
        const getEdgeColor = (e: any) => {
            const t = edgeWeightRatio(e.weight);
            if (e.isCenterEdge) return `rgba(74, 95, 132, ${(0.58 + t * 0.18).toFixed(2)})`;
            return `rgba(107, 124, 154, ${(0.46 + t * 0.16).toFixed(2)})`;
        };
        const getEdgeWidth = (e: any) => {
            const t = edgeWeightRatio(e.weight);
            return Math.min(2.4, 1.25 + t * 0.75 + (e.isCenterEdge ? 0.25 : 0));
        };
        let hovered: any = null;
        let dragging: any = null;

        const simulate = () => {
            for (const node of visibleNodes) {
                if (node.is_center || node === dragging) continue;
                let fx = 0, fy = 0;
                for (const o of visibleNodes) {
                    if (node === o) continue;
                    const dx = node.x - o.x, dy = node.y - o.y;
                    const d = Math.sqrt(dx * dx + dy * dy) || 1;
                    const f = 5000 / (d * d);
                    fx += (dx / d) * f; fy += (dy / d) * f;
                }
                for (const e of edges) {
                    let o = e.source === node ? e.target : (e.target === node ? e.source : null);
                    if (!o) continue;
                    fx += (o.x - node.x) * 0.01 * (e.weight / maxW);
                    fy += (o.y - node.y) * 0.01 * (e.weight / maxW);
                }
                fx += (cx - node.x) * 0.01; fy += (cy - node.y) * 0.01;
                node.vx = (node.vx + fx) * 0.85; node.vy = (node.vy + fy) * 0.85;
                node.x += node.vx; node.y += node.vy;
                node.x = Math.max(node.r + 20, Math.min(W - node.r - 20, node.x));
                node.y = Math.max(node.r + 20, Math.min(H - node.r - 20, node.y));
            }
        };

        const draw = () => {
            ctx.clearRect(0, 0, W, H);
            // 엣지: 옅은 회청색 범위에서 관계 강도만큼만 강조
            for (const e of edges) {
                ctx.beginPath();
                ctx.moveTo(e.source.x, e.source.y);
                ctx.lineTo(e.target.x, e.target.y);
                ctx.strokeStyle = getEdgeColor(e);
                ctx.lineWidth = getEdgeWidth(e);
                ctx.lineCap = 'round';
                ctx.stroke();
            }
            // 노드: 크기 = 공동 연구 수, 색상 = 그라데이션
            for (const node of visibleNodes) {
                ctx.beginPath();
                ctx.arc(node.x, node.y, node.r, 0, 2 * Math.PI);
                if (node.is_center) {
                    ctx.fillStyle = centerColor;
                } else if (node === hovered || node === dragging) {
                    ctx.fillStyle = '#3D5DB8';
                } else {
                    ctx.fillStyle = getNodeColor(node.collabCount);
                }
                ctx.fill();
                ctx.strokeStyle = node.is_center ? '#D07E1F' : '#4A5E8A';
                ctx.lineWidth = node.is_center ? 2 : 1.5;
                ctx.stroke();
                const name = node.name || '';
                const labelLimit = node.is_center ? 3 : (node.r < 18 ? 2 : (node.r < 24 ? 3 : 5));
                const label = name.length > labelLimit ? name.slice(0, labelLimit) + '…' : name;
                ctx.font = node.is_center ? 'bold 10px SUIT, sans-serif' : (node.r < 18 ? '10px SUIT, sans-serif' : '11px SUIT, sans-serif');
                ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
                ctx.fillStyle = '#fff';
                ctx.fillText(label, node.x, node.y);
                const displayCount = node.collabCount || this.getCollaborationCountValue(node);
                if (!node.is_center && displayCount) {
                    ctx.font = '600 10px SUIT, sans-serif';
                    ctx.lineWidth = 3;
                    ctx.strokeStyle = 'rgba(255, 255, 255, 0.88)';
                    ctx.strokeText(displayCount + '건', node.x, node.y + node.r + 12);
                    ctx.fillStyle = '#334155';
                    ctx.fillText(displayCount + '건', node.x, node.y + node.r + 12);
                }
            }
            const lx = 12, ly = H - 40;
            ctx.font = '10px SUIT, sans-serif';
            ctx.textAlign = 'left'; ctx.textBaseline = 'middle';
            ctx.fillStyle = '#9CA3AF';
            ctx.beginPath(); ctx.arc(lx + 6, ly, 5, 0, 2 * Math.PI);
            ctx.fillStyle = centerColor; ctx.fill();
            ctx.strokeStyle = '#D07E1F'; ctx.lineWidth = 2; ctx.stroke();
            ctx.fillText('중심 연구자', lx + 35, ly);
            ctx.beginPath(); ctx.arc(lx + 6, ly + 16, 5, 0, 2 * Math.PI);
            ctx.fillStyle = getNodeColor(minCollabCount + ((maxCollabCount - minCollabCount) * 0.5)); ctx.fill();
            ctx.strokeStyle = '#4A5E8A'; ctx.lineWidth = 1; ctx.stroke();
            ctx.fillStyle = '#9CA3AF';
            ctx.fillText('노드 크기 = 공동 연구 수', lx + 35, ly + 16);
        };

        if (this.animFrame) cancelAnimationFrame(this.animFrame);
        let frame = 0;
        const animate = () => {
            if (frame < 150) { simulate(); draw(); frame++; this.animFrame = requestAnimationFrame(animate); }
            else draw();
        };
        animate();

        const getMousePos = (ev: MouseEvent) => {
            const rect = canvas.getBoundingClientRect();
            return { x: ev.clientX - rect.left, y: ev.clientY - rect.top };
        };
        const findNode = (mx: number, my: number) => {
            for (const n of visibleNodes) {
                if ((mx - n.x) ** 2 + (my - n.y) ** 2 <= n.r * n.r) return n;
            }
            return null;
        };

        canvas.onmousedown = (ev: MouseEvent) => {
            const { x, y } = getMousePos(ev);
            const found = findNode(x, y);
            if (found && !found.is_center) {
                dragging = found;
                canvas.style.cursor = 'grabbing';
            }
        };

        canvas.onmousemove = (ev: MouseEvent) => {
            const { x, y } = getMousePos(ev);
            if (dragging) {
                dragging.x = Math.max(dragging.r + 20, Math.min(W - dragging.r - 20, x));
                dragging.y = Math.max(dragging.r + 20, Math.min(H - dragging.r - 20, y));
                dragging.vx = 0; dragging.vy = 0;
                draw();
                return;
            }
            const found = findNode(x, y);
            hovered = found;
            canvas.style.cursor = found && !found.is_center ? 'pointer' : 'default';
            if (frame >= 150) draw();
        };

        canvas.onmouseup = () => {
            if (dragging) {
                dragging = null;
                canvas.style.cursor = 'default';
            }
        };

        canvas.onmouseleave = () => {
            if (dragging) {
                dragging = null;
                canvas.style.cursor = 'default';
            }
            hovered = null;
            if (frame >= 150) draw();
        };

        canvas.onclick = (ev: MouseEvent) => {
            if (dragging) return;
        };

        canvas.ondblclick = (ev: MouseEvent) => {
            const { x, y } = getMousePos(ev);
            for (const n of nodes) {
                if (n.is_center) continue;
                if ((x - n.x) ** 2 + (y - n.y) ** 2 <= n.r * n.r) {
                    this.openCollabModal({
                        researcher_id: n.id,
                        collaboration_count: n.collabCount || n.collaboration_count || 0,
                        output_count: n.collabCount || n.output_count || 0,
                        publication_count: n.collabCount || n.publication_count || 0,
                        paper_count: n.collabCount || n.paper_count || 0,
                        researcher: {
                            researcher_id: n.id,
                            name_kor: n.name || '',
                            name_eng: ''
                        }
                    });
                    break;
                }
            }
        };
    }

    public changeTab(t: string) {
        const nextTab = this.normalizeTab(t);
        this.service.href(this.buildResearcherRoute(this.id, nextTab));
    }

    public tabClass(t: string) {
        if (this.tab === t) return 'border-[#4A6FD8] text-[#4A6FD8]';
        return 'border-transparent text-zinc-500 hover:text-zinc-700 hover:border-zinc-300';
    }

    public async changePubSort(sort: string) {
        if (this.pubSort === sort) {
            this.pubSortOrder = this.pubSortOrder === 'DESC' ? 'ASC' : 'DESC';
        } else {
            this.pubSort = sort;
            this.pubSortOrder = 'DESC';
        }
        await this.loadPublications(1);
    }

    public async searchPub() {
        await this.loadPublications(1);
    }

    private clearPaperFilterMenuCloseTimer() {
        if (!this.paperFilterMenuCloseTimer) return;
        clearTimeout(this.paperFilterMenuCloseTimer);
        this.paperFilterMenuCloseTimer = null;
    }

    public setPaperFilterMenuOpen(open: boolean) {
        this.clearPaperFilterMenuCloseTimer();
        if (open) {
            if (this.paperFilterMenuSuppressed) return;
            if (this.paperFilterMenuOpen) return;
            this.paperFilterMenuOpen = true;
            this.service.render();
            return;
        }
        this.paperFilterMenuCloseTimer = setTimeout(() => {
            this.paperFilterMenuCloseTimer = null;
            this.paperFilterMenuSuppressed = false;
            if (!this.paperFilterMenuOpen) return;
            this.paperFilterMenuOpen = false;
            this.service.render();
        }, 180);
    }

    public openPaperFilterMenu(event?: Event) {
        if (event) event.stopPropagation();
        this.clearPaperFilterMenuCloseTimer();
        this.paperFilterMenuSuppressed = false;
        if (this.paperFilterMenuOpen) return;
        this.paperFilterMenuOpen = true;
        this.service.render();
    }

    public async filterPubType(type: string, closePaperMenu: boolean = false) {
        this.pubFilterType = type;
        if (closePaperMenu) {
            this.clearPaperFilterMenuCloseTimer();
            this.paperFilterMenuOpen = false;
            this.paperFilterMenuSuppressed = true;
            const activeElement = document.activeElement as HTMLElement | null;
            if (activeElement?.blur) activeElement.blur();
        }
        await this.loadPublications(1);
    }

    public async filterPaperDefault() {
        if (this.getPublicationFilterCount('paper_domestic') > 0) {
            await this.filterPubType('paper_domestic', true);
            return;
        }
        if (this.getPublicationFilterCount('paper_overseas') > 0) {
            await this.filterPubType('paper_overseas', true);
            return;
        }
        await this.filterPubType('paper', true);
    }

    public async pubPageMove(page: number) {
        await this.loadPublications(page);
    }

    private getRawFieldTags(fields: any): string[] {
        if (!fields) return [];
        return String(fields).split(/[;|]/).map(f => f.trim()).filter(f => f);
    }

    public getFieldTags(fields: string): string[] {
        return this.sortKeywordTags(this.getRawFieldTags(fields));
    }

    public getResearcherKeywordField(): string {
        const keywordKor = String(this.researcher?.keyword_kor || '').trim();
        if (this.getFieldTags(keywordKor).length > 0) return keywordKor;
        return String(this.researcher?.keyword_eng || '').trim();
    }

    public getResearcherKeywordTags(): string[] {
        return this.getFieldTags(this.getResearcherKeywordField());
    }

    public getVisibleResearcherKeywords(): string[] {
        const all = this.getResearcherKeywordTags();
        if (this.showAllKeywords) return all;
        return all.slice(0, 8);
    }

    public hasMoreResearcherKeywords(): boolean {
        return this.getResearcherKeywordTags().length > 8;
    }

    private getKeywordFocusMatch(tag: string): any {
        const tagKey = this.normalizeKeywordTerm(tag);
        const fallback = { priority: 3, index: 999999 };
        if (!tagKey || this.keywordFocusTerms.length === 0) return fallback;

        for (let i = 0; i < this.keywordFocusTerms.length; i++) {
            if (tagKey === this.normalizeKeywordTerm(this.keywordFocusTerms[i])) {
                return { priority: 0, index: i };
            }
        }
        for (let i = 0; i < this.keywordFocusTerms.length; i++) {
            const keywordKey = this.normalizeKeywordTerm(this.keywordFocusTerms[i]);
            if (keywordKey && tagKey.includes(keywordKey)) {
                return { priority: 1, index: i };
            }
        }
        for (let i = 0; i < this.keywordFocusTerms.length; i++) {
            const keywordKey = this.normalizeKeywordTerm(this.keywordFocusTerms[i]);
            if (tagKey.length >= 2 && keywordKey.includes(tagKey)) {
                return { priority: 2, index: i };
            }
        }
        return fallback;
    }

    private sortKeywordTags(tags: string[]): string[] {
        if (this.keywordFocusTerms.length === 0) return tags;
        return tags
            .map((tag: string, index: number) => ({
                tag,
                index,
                match: this.getKeywordFocusMatch(tag)
            }))
            .sort((a: any, b: any) => {
                if (a.match.priority !== b.match.priority) return a.match.priority - b.match.priority;
                if (a.match.index !== b.match.index) return a.match.index - b.match.index;
                return a.index - b.index;
            })
            .map((item: any) => item.tag);
    }

    public isHighlightedKeyword(tag: string): boolean {
        return this.getKeywordFocusMatch(tag).priority < 3;
    }

    public getPublicationTypeLabel(pub: any): string {
        const docType = pub?.doc_type || '';
        if (docType === 'paper_overseas') return '해외논문';
        if (docType === 'paper') return this.hasOverseasPapers ? '국내논문' : '논문';
        if (docType === 'patent') return '특허';
        if (docType === 'report') return '보고서';
        return '성과물';
    }

    public getPublicationTypeClass(pub: any): string {
        const docType = pub?.doc_type || '';
        if (docType === 'paper_overseas') return 'bg-cyan-50 text-cyan-700';
        if (docType === 'paper') return 'bg-blue-50 text-blue-600';
        if (docType === 'patent') return 'bg-amber-50 text-amber-600';
        if (docType === 'report') return 'bg-green-50 text-green-600';
        return 'bg-zinc-100 text-zinc-600';
    }

    private isPublicationRegistryFlagEnabled(value: any): boolean {
        return String(value || '').trim().toUpperCase() === 'Y';
    }

    public getPublicationRegistryBadges(pub: any): any[] {
        const badgeMeta = [
            { key: 'sci', label: 'SCI', class: 'bg-indigo-50 text-indigo-700 border-indigo-100' },
            { key: 'wos', label: 'WOS', class: 'bg-sky-50 text-sky-700 border-sky-100' },
            { key: 'scopus', label: 'SCOPUS', class: 'bg-cyan-50 text-cyan-700 border-cyan-100' },
            { key: 'kci', label: 'KCI', class: 'bg-violet-50 text-violet-700 border-violet-100' },
            { key: 'rnd', label: '국가R&D', class: 'bg-emerald-50 text-emerald-700 border-emerald-100' },
        ];
        return badgeMeta.filter((badge: any) => this.isPublicationRegistryFlagEnabled(pub?.[badge.key]));
    }

    public hasPublicationRegistryBadges(pub: any): boolean {
        return this.getPublicationRegistryBadges(pub).length > 0;
    }

    public getModalPublicationTitle(): string {
        if (this.modalPubRootType === 'paper') return '논문 목록';
        if (this.modalPubType === 'paper_domestic') return '국내논문 목록';
        if (this.modalPubType === 'paper_overseas') return '해외논문 목록';
        if (this.modalPubType === 'paper') return this.hasOverseasPapers ? '논문 목록 (국내/해외 포함)' : '논문 목록';
        if (this.modalPubType === 'report') return '보고서 목록';
        if (this.modalPubType === 'patent') return '특허 목록';
        return '성과물 목록';
    }

    public getVisibleKeywords(fields: string): string[] {
        const all = this.getFieldTags(fields);
        if (this.showAllKeywords) return all;
        return all.slice(0, 8);
    }

    public hasMoreKeywords(fields: string): boolean {
        return this.getFieldTags(fields).length > 8;
    }

    public async toggleShowAllKeywords() {
        this.showAllKeywords = !this.showAllKeywords;
        await this.service.render();
    }

    // 16가지 유형 딕셔너리 (4축 × 2코드)
    public profileTypeDict: any = {
        // 축별 코드 설명
        codes: {
            'A': { short: '학술 중심', desc: '논문·학술 활동을 중심으로 연구 성과를 축적하며, 학회 발표 및 학술지 게재를 통해 이론적 기반을 확장하는 유형입니다. 주로 학술 커뮤니티에서 활발히 활동합니다.' },
            'I': { short: '산업 중심', desc: '산업 현장에서의 실용적 응용과 특허 출원을 중심으로 연구하며, 기술 이전 및 산학 공동 연구를 통해 연구 성과를 실질적으로 구현하는 유형입니다.' },
            'R': { short: '성장형', desc: '최근 연구 생산성이 빠르게 상승하고 있으며, 새로운 연구 분야에 진입하거나 기존 분야에서 연구 활동이 급격히 활발해지고 있는 유형입니다.' },
            'S': { short: '안정형', desc: '장기간에 걸쳐 꾸준하고 안정적으로 연구 성과를 유지하며, 일정한 연구 페이스와 지속적인 학술 활동을 보이는 유형입니다.' },
            'D': { short: '다학제형', desc: '다양한 학문 분야에 걸쳐 폭넓게 연구 활동을 수행하며, 여러 주제를 넘나들며 광범위한 연구 포트폴리오를 구축하는 유형입니다.' },
            'F': { short: '집중형', desc: '특정 연구 분야에 깊이 몰입하여 해당 분야의 전문성을 극대화하는 유형으로, 높은 인용도와 영향력을 보이는 경향이 있습니다.' },
            'C': { short: '융합형', desc: '여러 학문 분야의 이론과 방법론을 통합하여 학제 간 연구를 수행하며, 다양한 연구자와의 공동 연구를 통해 융합적 성과를 창출하는 유형입니다.' },
            'P': { short: '독립형', desc: '독자적인 연구 주제를 주도적으로 설정하고 수행하며, 단독 또는 소규모 팀에서 깊이 있는 연구를 이끌어가는 자기 주도적 유형입니다.' }
        },
        // 16가지 조합 유형 설명
        types: {
            'ASDC': '학술 논문을 주된 연구 성과로 삼으면서, 오랜 기간 안정적인 연구 활동을 유지해 온 연구자입니다. 다양한 학문 분야에 걸쳐 폭넓은 연구 포트폴리오를 보유하고 있으며, 여러 분야의 연구자들과 공동 연구를 통해 학제 간 융합 성과를 꾸준히 창출하는 것이 특징입니다.',
            'ASDP': '학술 중심의 연구 활동을 안정적으로 이어오면서, 다양한 연구 주제를 폭넓게 다루는 연구자입니다. 독자적인 연구 방향을 설정하고 주도적으로 수행하는 경향이 강하며, 여러 분야에서 자기만의 연구 색깔을 유지하며 독립적인 학술 성과를 지속적으로 쌓아가고 있습니다.',
            'ASFC': '학술 논문 중심으로 연구하면서 특정 전문 분야에 깊이 집중하는 안정적인 연구자입니다. 오랜 기간 핵심 전문성을 축적해 왔으며, 해당 분야의 방법론과 이론을 타 학문과 접목하여 융합적 관점의 연구를 수행합니다. 전문성과 융합 역량을 동시에 갖춘 균형 잡힌 연구 프로필이 특징입니다.',
            'ASFP': '특정 학문 분야에서 오랜 기간 꾸준히 깊이 있는 연구를 수행해 온 연구자입니다. 학술 논문을 통해 해당 분야의 이론적 토대를 다지고, 독자적인 연구 주제를 주도적으로 발전시켜 온 것이 특징입니다. 한 분야에서의 높은 전문성과 지속적인 연구 깊이가 강점입니다.',
            'ARDC': '학술 연구를 기반으로 최근 연구 생산성이 빠르게 성장하고 있는 연구자입니다. 다양한 학문 분야를 넘나들며 폭넓은 연구를 수행하고, 여러 분야의 연구자들과 적극적으로 공동 연구를 수행하여 학제 간 융합 성과를 빠른 속도로 확대하고 있습니다. 성장 잠재력과 융합 역량이 돋보이는 프로필입니다.',
            'ARDP': '학술 중심의 연구 활동에서 최근 급격한 성장세를 보이며, 다양한 분야에 걸쳐 독자적인 연구를 개척하고 있는 연구자입니다. 자기 주도적으로 새로운 연구 주제를 발굴하고, 여러 학문 영역을 자유롭게 탐색하면서 빠르게 연구 영역을 확장하는 것이 특징입니다.',
            'ARFC': '특정 전문 분야에서 빠르게 성장하면서, 해당 분야의 깊은 전문성을 학제 간 연구로 확장하고 있는 연구자입니다. 핵심 연구 역량을 기반으로 다른 학문과의 접점을 적극적으로 모색하며, 전문성과 융합 능력을 동시에 빠르게 발전시키고 있습니다.',
            'ARFP': '특정 학문 분야에 깊이 집중하면서 최근 연구 생산성이 급격히 상승하고 있는 연구자입니다. 독자적인 연구 방향을 설정하여 해당 분야에서 독보적인 역량을 빠르게 구축하고 있으며, 집중적이고 주도적인 연구 스타일로 단기간에 높은 성과를 달성하는 것이 강점입니다.',
            'ISDC': '특허와 기술 이전 등 산업 응용 중심의 연구를 안정적으로 수행하면서, 다양한 분야를 폭넓게 아우르는 연구자입니다. 여러 기술 영역의 지식을 통합하여 실용적인 관점에서 융합 연구를 수행하며, 산학 공동 연구를 통해 꾸준히 실질적인 성과를 창출하고 있습니다.',
            'ISDP': '산업 응용 중심의 연구를 다양한 분야에서 안정적으로 수행하는 독립적인 연구자입니다. 여러 산업 영역을 넘나들며 자기 주도적으로 연구 방향을 설정하고, 오랜 기간에 걸쳐 꾸준한 특허 출원과 기술 개발 성과를 독자적으로 이끌어가고 있습니다.',
            'ISFC': '특정 핵심 기술 분야에서 안정적으로 산업 응용 연구를 수행하면서, 해당 기술을 타 분야와 융합하여 새로운 가치를 창출하는 연구자입니다. 깊은 기술 전문성과 학제 간 공동 연구 능력을 겸비하고 있으며, 장기적인 관점에서 기술 융합 성과를 꾸준히 축적하는 것이 특징입니다.',
            'ISFP': '특정 기술 분야에서 오랜 기간 안정적으로 산업 응용 연구를 수행해 온 전문 연구자입니다. 해당 분야에서의 깊은 기술적 전문성을 바탕으로 독자적인 연구를 주도하며, 꾸준한 특허 출원과 기술 개발을 통해 해당 기술 영역의 핵심 연구자로 자리매김하고 있습니다.',
            'IRDC': '산업 응용 연구에서 최근 빠르게 성장하면서, 다양한 기술 분야를 통합하는 융합 역량을 갖춘 연구자입니다. 여러 산업 영역의 기술을 적극적으로 결합하여 새로운 응용 분야를 개척하고 있으며, 실용적 관점에서의 빠른 기술 통합 능력이 돋보이는 프로필입니다.',
            'IRDP': '여러 산업 분야에서 빠르게 성장하면서 독자적인 기술 개발을 주도하는 연구자입니다. 다양한 산업 영역을 자유롭게 탐색하며 자기 주도적으로 연구 방향을 설정하고, 최근 특허 출원과 기술 이전 성과가 급격히 증가하는 등 높은 성장 잠재력을 보이고 있습니다.',
            'IRFC': '핵심 기술 분야에서 빠르게 성장하면서, 해당 기술을 다른 분야와 접목하는 융합 연구에 강점을 보이는 연구자입니다. 특정 기술의 깊은 전문성을 기반으로 학제 간 공동 연구를 적극 추진하며, 기술 융합을 통한 새로운 산업 응용 가능성을 빠르게 확대하고 있습니다.',
            'IRFP': '특허와 기술 개발 중심으로 특정 분야에서 빠르게 성과를 확대하고 있는 연구자입니다. 독자적인 기술 로드맵을 설정하여 집중적으로 연구를 수행하며, 해당 기술 분야에서 단기간에 높은 영향력을 구축하고 있는 것이 특징입니다. 기술 전문성과 성장 속도 모두 우수합니다.'
        }
    };

    private getGraphAxisCode(axis: any): string {
        if (!axis) return '';
        const score = Number(axis.score ?? 50);
        const winner = score < 50 ? axis.left : axis.right;
        const codeMap: any = {
            Industrial: 'I',
            Academic: 'A',
            Steady: 'S',
            Rising: 'R',
            Focused: 'F',
            Diverse: 'D',
            Pure: 'P',
            Convergent: 'C',
        };
        return codeMap[winner] || axis.code || '';
    }

    private getGraphProfileCodes(): string[] {
        const axes = this.researchProfile?.axes || [];
        return axes
            .map((axis: any) => this.getGraphAxisCode(axis))
            .filter((code: string) => !!code);
    }

    private getGraphAxisTypeName(axis: any): string {
        const code = this.getGraphAxisCode(axis);
        const info = this.profileTypeDict.codes[code];
        return info?.short || axis?.type_name || '';
    }

    public getProfileDisplayCode(): string {
        const codes = this.getGraphProfileCodes();
        return codes.length ? codes.join('·') : (this.researchProfile?.code || '');
    }

    public getProfileDisplayName(): string {
        const codes = this.getGraphProfileCodes();
        if (!codes.length) return this.researchProfile?.combined_name || '';

        const shortNames: any = {
            A: '학술',
            I: '산업',
            R: '성장',
            S: '안정',
            D: '다학제',
            F: '집중',
            C: '융합',
            P: '순수전문',
        };
        const name = codes
            .map((code: string) => shortNames[code])
            .filter((label: string) => !!label)
            .join(' ');
        return name ? `${name}형 연구자` : (this.researchProfile?.combined_name || '');
    }

    public getProfileDescription(): string {
        if (!this.researchProfile || !this.researchProfile.axes) return '';
        const cleanCode = this.getProfileDisplayCode().replace(/[·\s]/g, '');
        const combinedName = this.getProfileDisplayName() || `${cleanCode}형 연구자`;
        const strongestAxes = [...this.researchProfile.axes]
            .sort((left: any, right: any) => Math.abs((right?.score || 50) - 50) - Math.abs((left?.score || 50) - 50))
            .slice(0, 2)
            .map((axis: any) => this.getGraphAxisTypeName(axis) || (axis?.score < 50 ? axis?.left : axis?.right))
            .filter((label: string) => !!label);
        if (strongestAxes.length >= 2) {
            return `${combinedName}입니다. ${strongestAxes[0]}과 ${strongestAxes[1]} 성향이 비교적 뚜렷합니다.`;
        }
        if (strongestAxes.length === 1) {
            return `${combinedName}입니다. ${strongestAxes[0]} 성향이 상대적으로 강합니다.`;
        }
        return `${combinedName}입니다.`;
    }

    private formatProfileMetric(value: number): string {
        if (!Number.isFinite(value)) return '0';
        return Math.abs(value - Math.round(value)) < 0.05 ? `${Math.round(value)}` : value.toFixed(1);
    }

    public getProfileAxisFormula(axis: any): string {
        if (!axis) return '';

        if (axis.key === 'impact') {
            return '학술 점수 = (논문 + 보고서) / (논문 + 보고서 + 특허) x 100 입니다. 51점 이상이면 Academic, 미만이면 Industrial로 판정합니다.';
        }

        if (axis.key === 'momentum') {
            return '활력 점수 = min(최근 3년 평균 / 전체 활동기간 평균 x 50, 100) 입니다. 51점 이상이면 Rising, 미만이면 Steady로 판정합니다.';
        }

        if (axis.key === 'breadth') {
            if (this.isStandardTopicHHI()) {
                return '다양성 점수는 AI 토픽맵 결과를 표준 과학기술 22개 대분류로 분류한 집중도를 기준으로 계산합니다. 값이 낮을수록 Diverse, 높을수록 Focused에 가깝습니다.';
            }
            if (this.isTopicMapHHI()) {
                return '다양성 점수는 AI 토픽맵의 연구 주제 집중도를 기준으로 계산합니다. 값이 낮을수록 Diverse, 높을수록 Focused에 가깝습니다.';
            }
            return '다양성 점수는 연구 주제 균등도와 문서당 고유 키워드 폭을 함께 반영합니다. 점수가 높을수록 Diverse에 가깝습니다.';
        }

        if (axis.key === 'interdisciplinary') {
            return '융합 점수 = 성과물별 키워드 카테고리 다양성의 가중 평균 x 100 입니다. 51점 이상이면 Convergent, 미만이면 Pure로 판정합니다.';
        }

        return axis.desc_en || '';
    }

    public getProfileAxisCurrentValue(axis: any): string {
        return axis?.evidence || '';
    }

    public getAxisNarrative(axis: any): string {
        if (!axis || !this.researchProfile?.weighting) return '';

        const weighting = this.researchProfile.weighting;
        const academicRatio = Number(weighting.academic_ratio ?? 50);
        const industrialRatio = Number((100 - academicRatio).toFixed(1));
        const recentAvg = Number(weighting.recent_avg ?? 0);
        const overallAvg = Number(weighting.overall_avg ?? 0);
        const risingRatio = this.getRisingRatio();
        const keywordHhi = Number(weighting.keyword_hhi ?? 0);

        if (axis.key === 'impact') {
            if (academicRatio >= 70) {
                return `산업 응용보다는 학술 연구에 뚜렷하게 집중된 성향으로, 논문·보고서 중심의 성과 비중이 ${this.formatProfileMetric(academicRatio)}%에 달합니다.`;
            }
            if (academicRatio >= 55) {
                return `학술 연구 쪽에 더 무게를 둔 성향으로, 논문·보고서 중심의 성과 비중이 ${this.formatProfileMetric(academicRatio)}%를 차지합니다.`;
            }
            if (academicRatio <= 30) {
                return `학술 연구보다는 산업 응용에 더 집중된 성향으로, 특허 중심의 산업형 성과 비중이 ${this.formatProfileMetric(industrialRatio)}%에 달합니다.`;
            }
            if (academicRatio <= 45) {
                return `산업 응용 쪽 비중이 더 높은 편으로, 특허 중심의 산업형 성과 비중이 ${this.formatProfileMetric(industrialRatio)}%를 차지합니다.`;
            }
            return `학술 연구와 산업 응용이 비교적 균형을 이루며, 학술 비중 ${this.formatProfileMetric(academicRatio)}%와 산업 비중 ${this.formatProfileMetric(industrialRatio)}%가 함께 나타납니다.`;
        }

        if (axis.key === 'momentum') {
            if (recentAvg <= 0 && overallAvg <= 0) {
                return '최근 연구 활력을 해석할 수 있는 연도별 성과 데이터는 아직 충분하지 않습니다.';
            }
            if (risingRatio >= 1.3) {
                return `최근 3년 가중 연평균은 ${this.formatProfileMetric(recentAvg)}건으로 전체 평균 ${this.formatProfileMetric(overallAvg)}건 대비 ${this.formatProfileMetric(risingRatio)}배 수준이며, 최근 연구 활력이 빠르게 상승하는 흐름입니다.`;
            }
            if (risingRatio >= 1.05) {
                return `최근 3년 가중 연평균은 ${this.formatProfileMetric(recentAvg)}건으로 전체 평균 ${this.formatProfileMetric(overallAvg)}건 대비 ${this.formatProfileMetric(risingRatio)}배 수준이며, 완만한 성장세를 이어가고 있습니다.`;
            }
            if (risingRatio >= 0.85) {
                return `최근 3년 가중 연평균은 ${this.formatProfileMetric(recentAvg)}건으로 전체 평균 ${this.formatProfileMetric(overallAvg)}건과 큰 차이가 없어, 장기간 안정적인 연구 페이스를 유지하고 있습니다.`;
            }
            return `최근 3년 가중 연평균은 ${this.formatProfileMetric(recentAvg)}건으로 전체 평균 ${this.formatProfileMetric(overallAvg)}건보다 낮아, 최근에는 비교적 차분한 속도로 연구를 이어가고 있습니다.`;
        }

        if (axis.key === 'breadth') {
            const focusLabel = '연구 주제 집중도';
            if (keywordHhi >= 0.4) {
                return `${focusLabel} ${this.formatProfileMetric(keywordHhi)}는 높은 수준으로, 특정 주제에 대한 전문성이 선명하며 한 분야를 깊게 파고드는 경향이 두드러집니다.`;
            }
            if (keywordHhi <= 0.2) {
                return `${focusLabel} ${this.formatProfileMetric(keywordHhi)}는 낮은 수준으로, 여러 주제를 폭넓게 탐색하는 편이며 다양한 연구 접점을 만들어 가는 경향이 강합니다.`;
            }
            if (axis.code === 'F') {
                return `${focusLabel} ${this.formatProfileMetric(keywordHhi)}는 중간 수준이지만, 전반적으로는 특정 전문 영역을 중심으로 연구 포트폴리오를 쌓아가는 모습이 더 뚜렷합니다.`;
            }
            return `${focusLabel} ${this.formatProfileMetric(keywordHhi)}는 중간 수준으로, 특정 전문성을 유지하면서도 인접 주제로 연구 범위를 확장하는 균형형 성향을 보입니다.`;
        }

        if (axis.key === 'interdisciplinary') {
            const dominantScore = axis.score >= 50 ? axis.score : 100 - axis.score;
            if (axis.code === 'C') {
                return `개별 성과물 안에서 서로 다른 주제를 함께 연결하는 비중이 ${this.formatProfileMetric(dominantScore)}% 수준으로 나타나, 인접 분야를 엮는 융합 연구 성향이 비교적 뚜렷합니다.`;
            }
            return `개별 성과물의 주제 구성이 ${this.formatProfileMetric(dominantScore)}% 수준으로 한 방향에 더 모여 있어, 한 분야 안에서 깊이를 쌓는 순수 전문형 경향이 상대적으로 강합니다.`;
        }

        return this.getAxisGraphHint(axis);
    }

    public getNetworkLimitNoticeText(): string {
        return `공동저자 ${this.coauthors.length}명 중 공동연구를 ${this.networkGraphCutoffCollaborationCount}건 이상 수행한 연구자 ${this.networkCandidateCount}명이 표시됩니다.`;
    }

    public getNetworkFilterNoticeText(): string {
        return `공동저자 ${this.coauthors.length}명 중 공동연구를 ${this.effectiveCollabThreshold}건 이상 수행한 연구자 ${this.networkVisibleCoauthorCount}명이 표시됩니다.`;
    }

    public getNetworkSummaryNoticeText(): string {
        return `공동저자 ${this.coauthors.length}명 중 공동연구를 ${this.effectiveCollabThreshold}건 이상 수행한 연구자 ${this.networkVisibleCoauthorCount}명이 표시됩니다.`;
    }

    public getAxisDescription(axis: any): string {
        const info = this.profileTypeDict.codes[this.getGraphAxisCode(axis)];
        return info ? info.desc : '';
    }

    public getAxisGraphHint(axis: any): string {
        if (!axis) return '';

        const score = Number(axis.score ?? 50);
        const leaningLeft = score < 50;
        const dominant = leaningLeft ? axis.left : axis.right;
        const opposite = leaningLeft ? axis.right : axis.left;
        const dominantScore = leaningLeft ? 100 - score : score;
        const gap = Math.abs(score - 50);

        let intensity = '완만하게';
        if (gap >= 25) intensity = '뚜렷하게';
        else if (gap >= 12) intensity = '비교적 분명하게';

        const evidence = axis.evidence ? ` ${axis.evidence}` : '';
        return `${dominant} 쪽으로 ${intensity} 기울어 있습니다 (${dominantScore}%).${evidence}`.trim();
    }

    // === 지표 카드 헬퍼 ===

    private getAcademicRatioValue(): number {
        const total = this.displayTotalPubs;
        if (total > 0) {
            return ((this.displayPaperCnt + this.displayReportCnt) / total) * 100;
        }
        return Math.max(0, Math.min(100, Number(this.researchProfile?.weighting?.academic_ratio || 0)));
    }

    public getAcademicRatio(): string {
        return this.getAcademicRatioValue().toFixed(1);
    }

    public getIndustrialRatio(): string {
        return (100 - this.getAcademicRatioValue()).toFixed(1);
    }

    public getAcademicIndustryRingStyle(): string {
        const academic = this.getAcademicRatioValue();
        return `conic-gradient(#4A6FD8 0 ${academic}%, #F2B84B ${academic}% 100%)`;
    }

    public getRisingRatio(): number {
        if (!this.researchProfile?.weighting) return 1;
        const { recent_avg, overall_avg } = this.researchProfile.weighting;
        if (!overall_avg || overall_avg <= 0) return recent_avg > 0 ? 1.5 : 1;
        return recent_avg / overall_avg;
    }

    public getRecentBarWidth(): number {
        if (!this.researchProfile?.weighting) return 0;
        const { recent_avg, overall_avg } = this.researchProfile.weighting;
        const maxVal = Math.max(recent_avg, overall_avg, 1);
        return Math.min((recent_avg / maxVal) * 100, 100);
    }

    public getRecentBarHeight(): number {
        return this.getRecentBarWidth();
    }

    public getOverallBarWidth(): number {
        if (!this.researchProfile?.weighting) return 0;
        const { recent_avg, overall_avg } = this.researchProfile.weighting;
        const maxVal = Math.max(recent_avg, overall_avg, 1);
        return Math.min((overall_avg / maxVal) * 100, 100);
    }

    public getOverallBarHeight(): number {
        return this.getOverallBarWidth();
    }

    public isKeywordFocusLoading(): boolean {
        if (!this.researchProfile?.weighting) return true;
        if (this.topicProfileLoading) return true;
        return this.topicProfileResolvedForId !== this.id;
    }

    public isResearchProfileLoading(): boolean {
        return !this.researchProfile || this.isKeywordFocusLoading();
    }

    public isBreadthAxisLoading(axis: any): boolean {
        return axis?.key === 'breadth' && this.isKeywordFocusLoading();
    }

    public getHHILabel(): string {
        if (!this.researchProfile?.weighting) return '';
        const hhi = this.researchProfile.weighting.keyword_hhi;
        if (hhi >= 0.40) return '전문가형 (집중)';
        if (hhi <= 0.20) return '융합형 (분산)';
        return '균형형';
    }

    public isTopicMapHHI(): boolean {
        const source = this.researchProfile?.weighting?.keyword_hhi_source;
        return source === 'topicmap_ai' || source === 'topicmap_standard';
    }

    public isStandardTopicHHI(): boolean {
        return this.researchProfile?.weighting?.keyword_hhi_source === 'topicmap_standard';
    }

    public getHHIBasisLabel(): string {
        if (!this.researchProfile?.weighting) return '';
        if (this.isStandardTopicHHI()) {
            const count = Number(this.researchProfile.weighting.topic_cluster_count || 0);
            return count > 0 ? `표준 과학기술 22개 대분류 중 ${count}개 분류` : '표준 과학기술 22개 대분류';
        }
        if (this.isTopicMapHHI()) {
            const count = Number(this.researchProfile.weighting.topic_cluster_count || 0);
            return count > 0 ? `AI 토픽맵 ${count}개 주제 클러스터` : 'AI 토픽맵 주제 클러스터';
        }
        return '성과물 연구 주제 분포';
    }

    public getHHIColorClass(): string {
        if (!this.researchProfile?.weighting) return 'text-zinc-600';
        const hhi = this.researchProfile.weighting.keyword_hhi;
        if (hhi >= 0.40) return 'text-amber-500';
        if (hhi <= 0.20) return 'text-violet-500';
        return 'text-zinc-600';
    }

    public getHHIMarkerPosition(): string {
        if (!this.researchProfile?.weighting) return '50%';
        const hhi = Number(this.researchProfile.weighting.keyword_hhi || 0);
        const position = Math.max(0, Math.min((hhi / 0.6) * 100, 100));
        return `${position}%`;
    }

    public getHHIExplanation(): string {
        if (!this.researchProfile?.weighting) return '';
        const hhi = this.researchProfile.weighting.keyword_hhi;
        const basis = this.isStandardTopicHHI()
            ? 'AI 토픽맵 결과를 표준 과학기술 22개 대분류로 분류한 빈도 분포 기준입니다. '
            : (this.isTopicMapHHI() ? 'AI 토픽맵에서 묶은 주제 클러스터별 빈도 분포 기준입니다. ' : '');
        if (hhi >= 0.40) {
            return `${basis}소수 주제에 연구가 집중되어 높은 집중도를 나타냅니다.`;
        }
        if (hhi <= 0.20) {
            return `${basis}다양한 주제가 고르게 분포하여 낮은 집중도를 보입니다.`;
        }
        return `${basis}특정 주제 집중과 다양성이 혼합된 중간 수준입니다.`;
    }

    public onCollabThresholdInput(value: number) {
        const minThreshold = Math.max(1, this.collabThresholdFloor || 1);
        const parsed = Math.floor(Number(value) || minThreshold);
        if (parsed < minThreshold) {
            this.collabThreshold = minThreshold;
            this.showToast(`공동연구 최소 필터는 ${minThreshold}건 미만으로 내릴 수 없습니다.`);
            return;
        }
        this.collabThreshold = this.normalizeCollabThreshold(value);
    }

    public async changeCollabThreshold(value: number) {
        const minThreshold = Math.max(1, this.collabThresholdFloor || 1);
        const parsed = Math.floor(Number(value) || minThreshold);
        if (parsed < minThreshold) {
            this.collabThreshold = minThreshold;
            this.showToast(`공동연구 최소 필터는 ${minThreshold}건 미만으로 내릴 수 없습니다.`);
            await this.service.render();
            return;
        }
        const v = this.normalizeCollabThreshold(value);
        this.collabThreshold = v;
        await this.service.render();
        setTimeout(() => this.drawNetworkGraph(), 50);
    }

    public async showToast(message: string) {
        this.toastMessage = message;
        this.toastVisible = true;
        if (this.toastTimer) clearTimeout(this.toastTimer);
        await this.service.render();
        this.toastTimer = setTimeout(async () => {
            this.toastVisible = false;
            await this.service.render();
        }, 3000);
    }

    public goResearcher(id: string) {
        this.service.href(`/researcher/${id}`);
    }

    public openResearcherNewTab(id: string) {
        window.open(`/researcher/${id}`, '_blank', 'noopener,noreferrer');
    }

    public openExternalLink(url: string) {
        if (!url) return;
        window.open(url, '_blank', 'noopener,noreferrer');
    }

    public goScienceON(pub: any) {
        if (!pub || !pub.doc_id) return;
        const docId = String(pub.doc_id || '').trim();
        if (docId.startsWith('W')) {
            window.open(`https://openalex.org/${encodeURIComponent(docId)}`, '_blank', 'noopener,noreferrer');
            return;
        }
        const urlMap: any = {
            report: 'selectPORSrchReport',
            paper: 'selectPORSrchArticle',
            paper_overseas: 'selectPORSrchArticle',
            patent: 'selectPORSrchPatent'
        };
        const action = urlMap[pub.doc_type] || 'selectPORSrchArticle';
        const url = `https://scienceon.kisti.re.kr/srch/${action}.do?cn=${encodeURIComponent(docId)}`;
        window.open(url, '_blank', 'noopener,noreferrer');
    }

    public getBarWidth(count: number): number {
        const data = this.filteredYearlyData;
        if (!data || data.length === 0) return 0;
        const max = Math.max(...data.map(y => y.count || 0));
        return max > 0 ? (count / max) * 100 : 0;
    }

    public getRelWeight(weight: number): number {
        if (!this.related || this.related.length === 0) return 0;
        const max = Math.max(...this.related.map(r => r.weight || 0));
        return max > 0 ? (weight / max) * 100 : 0;
    }

    public async checkSession() {
        try {
            const { code, data } = await wiz.call("check_session");
            this.isLoggedIn = !!(code === 200 && data.loggedIn);
            this.isAdmin = !!(code === 200 && data.isAdmin);
            if (this.isLoggedIn) {
                await this.checkBookmark();
            } else {
                this.isBookmarked = false;
            }
        } catch (e) { }
    }

    public async checkBookmark() {
        if (!this.isLoggedIn || !this.id) return;
        const { code, data } = await wiz.call("check_bookmark", { researcher_id: this.id });
        if (code === 200) {
            this.isBookmarked = data.bookmarked;
        }
    }

    public async toggleBookmark() {
        if (!this.isLoggedIn) return;
        const { code, data } = await wiz.call("toggle_bookmark", { researcher_id: this.id });
        if (code === 200) {
            this.isBookmarked = data.bookmarked;
        }
        await this.service.render();
    }
}

export default PageResearcherItemComponent;